"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var AuthHeaders_1 = require("./AuthHeaders");
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var moment = require("moment");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
exports.API_BASE_URL = new core_1.InjectionToken('API_BASE_URL');
var ClientBase = /** @class */ (function () {
    function ClientBase() {
    }
    ClientBase.prototype.transformOptions = function (options) {
        var token = AuthHeaders_1.getAuthToken();
        var old_headers = options.headers;
        var new_headers = {};
        old_headers.keys().forEach(function (k) {
            new_headers[k] = old_headers.get(k);
        });
        if (token && token != '') {
            new_headers["Authorization"] = "Bearer " + token;
        }
        Object.keys(AuthHeaders_1.default_headers).forEach(function (k) {
            new_headers[k] = AuthHeaders_1.default_headers[k];
        });
        options.headers = new http_1.HttpHeaders(new_headers);
        //console.log("HTTP call, options: " + JSON.stringify(options));
        return Promise.resolve(options);
    };
    ClientBase.prototype.transformResult = function (url, response, processor) {
        // TODO: Return own result or throw exception to change default processing behavior, 
        // or call processor function to run the default processing logic
        //console.log("Service call: " + url);
        return processor(response);
    };
    return ClientBase;
}());
exports.ClientBase = ClientBase;
var AdsClient = /** @class */ (function (_super) {
    __extends(AdsClient, _super);
    function AdsClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    AdsClient.prototype.getAds = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Ads";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetAds(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetAds(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdsClient.prototype.processGetAds = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Ads.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdsClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdsClient_Factory() { return new AdsClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: AdsClient, providedIn: "root" });
    return AdsClient;
}(ClientBase));
exports.AdsClient = AdsClient;
var AdveristmentsClient = /** @class */ (function (_super) {
    __extends(AdveristmentsClient, _super);
    function AdveristmentsClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    AdveristmentsClient.prototype.markAsSeenByDemo = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/markAsSeen";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processMarkAsSeenByDemo(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processMarkAsSeenByDemo(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processMarkAsSeenByDemo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdvertisementMarkAsSeenResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getCategories = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetCategories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetCategories(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetCategories(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetCategories = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(DTOAdvertisementCategory.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getCategoriesJS = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/getcategories/js";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetCategoriesJS(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetCategoriesJS(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetCategoriesJS = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getRegions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetRegions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetRegions(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetRegions(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(DTORegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getRegionsOnly = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetRegionsOnly";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetRegionsOnly(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetRegionsOnly(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetRegionsOnly = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(DTORegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getChildrenSubRegions = function (subRegionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetChildrenSubRegions/{subRegionId}";
        if (subRegionId === undefined || subRegionId === null)
            throw new Error("The parameter 'subRegionId' must be defined.");
        url_ = url_.replace("{subRegionId}", encodeURIComponent("" + subRegionId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetChildrenSubRegions(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetChildrenSubRegions(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetChildrenSubRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(DTOSubRegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.repost = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/repost";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processRepost(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processRepost(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processRepost = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdvertistmentRepostResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.create = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentCreateResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.update = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentUpdateResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.delete = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/delete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processDelete = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentDeleteResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getAdvertisementData = function (advId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetAdvertisementData?";
        if (advId === null)
            throw new Error("The parameter 'advId' cannot be null.");
        else if (advId !== undefined)
            url_ += "advId=" + encodeURIComponent("" + advId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetAdvertisementData(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetAdvertisementData(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetAdvertisementData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentGetResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.get = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/get";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdveristmentGetResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getGoogleKey = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetGoogleKey";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetGoogleKey(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetGoogleKey(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetGoogleKey = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.getBlogUrl = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/GetBlogUrl";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetBlogUrl(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetBlogUrl(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processGetBlogUrl = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.prototype.createAdWriteInformation = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Adveristments/CreateAdWriteInformation";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreateAdWriteInformation(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreateAdWriteInformation(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AdveristmentsClient.prototype.processCreateAdWriteInformation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AdWritterInformationResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AdveristmentsClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdveristmentsClient_Factory() { return new AdveristmentsClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: AdveristmentsClient, providedIn: "root" });
    return AdveristmentsClient;
}(ClientBase));
exports.AdveristmentsClient = AdveristmentsClient;
var AuthClient = /** @class */ (function (_super) {
    __extends(AuthClient, _super);
    function AuthClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    AuthClient.prototype.login = function (user) {
        var _this = this;
        var url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(user);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processLogin(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processLogin(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    AuthClient.prototype.processLogin = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = LoginResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    AuthClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthClient_Factory() { return new AuthClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: AuthClient, providedIn: "root" });
    return AuthClient;
}(ClientBase));
exports.AuthClient = AuthClient;
var CaptchaClient = /** @class */ (function (_super) {
    __extends(CaptchaClient, _super);
    function CaptchaClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    CaptchaClient.prototype.getCaptchaKey = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Captcha/GetCaptchaKey";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetCaptchaKey(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetCaptchaKey(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    CaptchaClient.prototype.processGetCaptchaKey = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    CaptchaClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CaptchaClient_Factory() { return new CaptchaClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: CaptchaClient, providedIn: "root" });
    return CaptchaClient;
}(ClientBase));
exports.CaptchaClient = CaptchaClient;
var ConversationClient = /** @class */ (function (_super) {
    __extends(ConversationClient, _super);
    function ConversationClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    ConversationClient.prototype.deleteConversation = function (deleteRequestModel) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/delete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(deleteRequestModel);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processDeleteConversation(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processDeleteConversation(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processDeleteConversation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ConversationDeleteResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.getConversation = function (conversationId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/getConversation?";
        if (conversationId === null)
            throw new Error("The parameter 'conversationId' cannot be null.");
        else if (conversationId !== undefined)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetConversation(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetConversation(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processGetConversation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetConversationResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.getConversations = function (requestModel) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/get";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(requestModel);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetConversations(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetConversations(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processGetConversations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UserConversationsResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.sendConversationMessage = function (requestModel) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/sendConversationMessage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(requestModel);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSendConversationMessage(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSendConversationMessage(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processSendConversationMessage = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MessageSubmitResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.sendStartingMessage = function (requestModel) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/sendStartingMessage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(requestModel);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSendStartingMessage(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSendStartingMessage(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processSendStartingMessage = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MessageSubmitResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.getUnreadedMessages = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/GetUnreadedMessages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetUnreadedMessages(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetUnreadedMessages(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processGetUnreadedMessages = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.prototype.setReadedMessages = function (messagesIds, conversationId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Conversation/SetReadedMessages?";
        if (conversationId === null)
            throw new Error("The parameter 'conversationId' cannot be null.");
        else if (conversationId !== undefined)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(messagesIds);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSetReadedMessages(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSetReadedMessages(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ConversationClient.prototype.processSetReadedMessages = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ConversationClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConversationClient_Factory() { return new ConversationClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: ConversationClient, providedIn: "root" });
    return ConversationClient;
}(ClientBase));
exports.ConversationClient = ConversationClient;
var EmojiClient = /** @class */ (function (_super) {
    __extends(EmojiClient, _super);
    function EmojiClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    EmojiClient.prototype.getEmojis = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Emoji/GetEmojis";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetEmojis(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetEmojis(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    EmojiClient.prototype.processGetEmojis = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = EmojiResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    EmojiClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmojiClient_Factory() { return new EmojiClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: EmojiClient, providedIn: "root" });
    return EmojiClient;
}(ClientBase));
exports.EmojiClient = EmojiClient;
var FileClient = /** @class */ (function (_super) {
    __extends(FileClient, _super);
    function FileClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    FileClient.prototype.read = function (pathInfo, maxWidth, maxheight) {
        var _this = this;
        var url_ = this.baseUrl + "/FileGet/{pathInfo}/{maxWidth}x{maxheight}";
        if (pathInfo === undefined || pathInfo === null)
            throw new Error("The parameter 'pathInfo' must be defined.");
        url_ = url_.replace("{pathInfo}", encodeURIComponent("" + pathInfo));
        if (maxWidth === undefined || maxWidth === null)
            throw new Error("The parameter 'maxWidth' must be defined.");
        url_ = url_.replace("{maxWidth}", encodeURIComponent("" + maxWidth));
        if (maxheight === undefined || maxheight === null)
            throw new Error("The parameter 'maxheight' must be defined.");
        url_ = url_.replace("{maxheight}", encodeURIComponent("" + maxheight));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processRead(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processRead(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    FileClient.prototype.processRead = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    FileClient.prototype.read2 = function (pathInfo) {
        var _this = this;
        var url_ = this.baseUrl + "/FileGet/{pathInfo}";
        if (pathInfo === undefined || pathInfo === null)
            throw new Error("The parameter 'pathInfo' must be defined.");
        url_ = url_.replace("{pathInfo}", encodeURIComponent("" + pathInfo));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processRead2(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processRead2(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    FileClient.prototype.processRead2 = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    FileClient.prototype.temporaryUpload = function () {
        var _this = this;
        var url_ = this.baseUrl + "/File/TemporaryUpload";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processTemporaryUpload(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processTemporaryUpload(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    FileClient.prototype.processTemporaryUpload = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    FileClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FileClient_Factory() { return new FileClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: FileClient, providedIn: "root" });
    return FileClient;
}(ClientBase));
exports.FileClient = FileClient;
var GeolocationClient = /** @class */ (function (_super) {
    __extends(GeolocationClient, _super);
    function GeolocationClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    GeolocationClient.prototype.subRegionByLatLng = function (latitude, longitude) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/ClosestSubRegionByLatLng?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSubRegionByLatLng(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSubRegionByLatLng(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processSubRegionByLatLng = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubRegion.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.asd = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/Test";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processAsd(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processAsd(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processAsd = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(SubRegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.cityMostPopulation = function (top) {
        var _this = this;
        var url_ = this.baseUrl + "/citybypopulation?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCityMostPopulation(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCityMostPopulation(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processCityMostPopulation = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(SubRegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.cityMostPopulationJS = function (top) {
        var _this = this;
        var url_ = this.baseUrl + "/citybypopulation/js?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCityMostPopulationJS(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCityMostPopulationJS(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processCityMostPopulationJS = function (response) {
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getSubregionByZip = function (zip) {
        var _this = this;
        var url_ = this.baseUrl + "/SubregionByZip?";
        if (zip !== undefined)
            url_ += "zip=" + encodeURIComponent("" + zip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetSubregionByZip(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetSubregionByZip(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetSubregionByZip = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubRegion.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getSubregionByIP = function (ip) {
        var _this = this;
        var url_ = this.baseUrl + "/GetSubregionByIP?";
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetSubregionByIP(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetSubregionByIP(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetSubregionByIP = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubRegion.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.clientIp = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/clientIP";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processClientIp(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processClientIp(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processClientIp = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(item);
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getNearestCity = function (ip) {
        var _this = this;
        var url_ = this.baseUrl + "/GetNearestCity?";
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetNearestCity(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetNearestCity(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetNearestCity = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.allSubregions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/AllSubregions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processAllSubregions(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processAllSubregions(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processAllSubregions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(SubRegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.allRegions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/AllRegions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processAllRegions(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processAllRegions(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processAllRegions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                        var item = resultData200_9[_i];
                        result200.push(Region.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getSubregion = function (subregionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/GetSubregion?";
        if (subregionId === null)
            throw new Error("The parameter 'subregionId' cannot be null.");
        else if (subregionId !== undefined)
            url_ += "subregionId=" + encodeURIComponent("" + subregionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetSubregion(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetSubregion(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetSubregion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = SubRegion.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.prototype.getRegion = function (regionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Geolocation/GetRegion?";
        if (regionId === null)
            throw new Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetRegion(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetRegion(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    GeolocationClient.prototype.processGetRegion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Region.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    GeolocationClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GeolocationClient_Factory() { return new GeolocationClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: GeolocationClient, providedIn: "root" });
    return GeolocationClient;
}(ClientBase));
exports.GeolocationClient = GeolocationClient;
var ImportDataClient = /** @class */ (function (_super) {
    __extends(ImportDataClient, _super);
    function ImportDataClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    ImportDataClient.prototype.usStates = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/ImportData/usstates";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processUsStates(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processUsStates(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ImportDataClient.prototype.processUsStates = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ImportDataClient.prototype.test = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/ImportData/test";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processTest(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processTest(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ImportDataClient.prototype.processTest = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                        var item = resultData200_10[_i];
                        result200.push(SubRegion.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ImportDataClient.prototype.importPopularity = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/ImportData/popularity";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processImportPopularity(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processImportPopularity(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    ImportDataClient.prototype.processImportPopularity = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    ImportDataClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ImportDataClient_Factory() { return new ImportDataClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: ImportDataClient, providedIn: "root" });
    return ImportDataClient;
}(ClientBase));
exports.ImportDataClient = ImportDataClient;
var PhoneValidationClient = /** @class */ (function (_super) {
    __extends(PhoneValidationClient, _super);
    function PhoneValidationClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    PhoneValidationClient.prototype.sendPhoneValidationSms = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/send";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSendPhoneValidationSms(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSendPhoneValidationSms(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    PhoneValidationClient.prototype.processSendPhoneValidationSms = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = VerifyPhoneResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    PhoneValidationClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PhoneValidationClient_Factory() { return new PhoneValidationClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: PhoneValidationClient, providedIn: "root" });
    return PhoneValidationClient;
}(ClientBase));
exports.PhoneValidationClient = PhoneValidationClient;
var SampleDataClient = /** @class */ (function (_super) {
    __extends(SampleDataClient, _super);
    function SampleDataClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    SampleDataClient.prototype.zipTest = function (zip) {
        var _this = this;
        var url_ = this.baseUrl + "/api/SampleData/ZipTest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(zip);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processZipTest(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processZipTest(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SampleDataClient.prototype.processZipTest = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SampleDataClient.prototype.weatherForecasts = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/SampleData/WeatherForecasts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processWeatherForecasts(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processWeatherForecasts(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SampleDataClient.prototype.processWeatherForecasts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                        var item = resultData200_11[_i];
                        result200.push(WeatherForecast.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SampleDataClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SampleDataClient_Factory() { return new SampleDataClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: SampleDataClient, providedIn: "root" });
    return SampleDataClient;
}(ClientBase));
exports.SampleDataClient = SampleDataClient;
var SubscribtionClient = /** @class */ (function (_super) {
    __extends(SubscribtionClient, _super);
    function SubscribtionClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    SubscribtionClient.prototype.create = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CreateServiceResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.subscribtionData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processSubscribtionData(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processSubscribtionData(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processSubscribtionData = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                        var item = resultData200_12[_i];
                        result200.push(SubscribtionData.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.cancelSubscribtion = function (subscribtionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/CancelSubscribtion?";
        if (subscribtionId !== undefined)
            url_ += "subscribtionId=" + encodeURIComponent("" + subscribtionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCancelSubscribtion(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCancelSubscribtion(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processCancelSubscribtion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.hasUserSubscribtion = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/HasUserSubscribtion";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processHasUserSubscribtion(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processHasUserSubscribtion(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processHasUserSubscribtion = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.createPremiumAdToken = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/CreatePremiumAdToken";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreatePremiumAdToken(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreatePremiumAdToken(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processCreatePremiumAdToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AddPremiumAdTokenResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.getUserPremiumAdTokens = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/GetUserPremiumAdTokens";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetUserPremiumAdTokens(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetUserPremiumAdTokens(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processGetUserPremiumAdTokens = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.createWriteAdToken = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/CreateWriteAdToken";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processCreateWriteAdToken(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processCreateWriteAdToken(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processCreateWriteAdToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AddWriteAdTokenResponse.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.prototype.getWriteAdToken = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscribtion/GetWriteAdToken";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetWriteAdToken(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetWriteAdToken(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    SubscribtionClient.prototype.processGetWriteAdToken = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    SubscribtionClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SubscribtionClient_Factory() { return new SubscribtionClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: SubscribtionClient, providedIn: "root" });
    return SubscribtionClient;
}(ClientBase));
exports.SubscribtionClient = SubscribtionClient;
var TestClient = /** @class */ (function (_super) {
    __extends(TestClient, _super);
    function TestClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    TestClient.prototype.getDemo = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Test/GetDemo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetDemo(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetDemo(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    TestClient.prototype.processGetDemo = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                        var item = resultData200_13[_i];
                        result200.push(TupleOfIntegerAndDateTime.fromJS(item));
                    }
                }
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    TestClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TestClient_Factory() { return new TestClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: TestClient, providedIn: "root" });
    return TestClient;
}(ClientBase));
exports.TestClient = TestClient;
var UserClient = /** @class */ (function (_super) {
    __extends(UserClient, _super);
    function UserClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    UserClient.prototype.register = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/register";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processRegister(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processRegister(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processRegister = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RegistrationResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.resetPassword = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/passwordreset";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processResetPassword(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processResetPassword(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processResetPassword = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ResetPasswordResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.getEmailFromCode = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/getemailfromcode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processGetEmailFromCode(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processGetEmailFromCode(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processGetEmailFromCode = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GetEmailFromCodeResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.newPassword = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/newpassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processNewPassword(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processNewPassword(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processNewPassword = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ResetPasswordResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.validatePhone = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/phoneValidate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processValidatePhone(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processValidatePhone(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processValidatePhone = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ValidateResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.prototype.validateEmail = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/User/emailValidate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("post", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processValidateEmail(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processValidateEmail(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    UserClient.prototype.processValidateEmail = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ValidateResponseModel.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    UserClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserClient_Factory() { return new UserClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: UserClient, providedIn: "root" });
    return UserClient;
}(ClientBase));
exports.UserClient = UserClient;
var VersionClient = /** @class */ (function (_super) {
    __extends(VersionClient, _super);
    function VersionClient(http, baseUrl) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http;
        _this.baseUrl = baseUrl ? baseUrl : "http://wicked.infosystrade.com";
        return _this;
    }
    VersionClient.prototype.versionHash = function (t) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Version?";
        if (t !== undefined)
            url_ += "t=" + encodeURIComponent("" + t) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return rxjs_1.from(this.transformOptions(options_)).pipe(operators_1.mergeMap(function (transformedOptions_) {
            return _this.http.request("get", url_, transformedOptions_);
        })).pipe(operators_1.mergeMap(function (response_) {
            return _this.processVersionHash(response_);
        })).pipe(operators_1.catchError(function (response_) {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return _this.processVersionHash(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    };
    VersionClient.prototype.processVersionHash = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return rxjs_1.of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    };
    VersionClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VersionClient_Factory() { return new VersionClient(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(exports.API_BASE_URL, 8)); }, token: VersionClient, providedIn: "root" });
    return VersionClient;
}(ClientBase));
exports.VersionClient = VersionClient;
var Ads = /** @class */ (function () {
    function Ads(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Ads.prototype.init = function (_data) {
        if (_data) {
            this.leftAdId = _data["leftAdId"] !== undefined ? _data["leftAdId"] : null;
            this.rightAdId = _data["rightAdId"] !== undefined ? _data["rightAdId"] : null;
            this.mobileAdId = _data["mobileAdId"] !== undefined ? _data["mobileAdId"] : null;
        }
    };
    Ads.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Ads();
        result.init(data);
        return result;
    };
    Ads.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["leftAdId"] = this.leftAdId !== undefined ? this.leftAdId : null;
        data["rightAdId"] = this.rightAdId !== undefined ? this.rightAdId : null;
        data["mobileAdId"] = this.mobileAdId !== undefined ? this.mobileAdId : null;
        return data;
    };
    Ads.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Ads();
        result.init(json);
        return result;
    };
    return Ads;
}());
exports.Ads = Ads;
var ResponseBaseModel = /** @class */ (function () {
    function ResponseBaseModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResponseBaseModel.prototype.init = function (_data) {
        if (_data) {
            this.error = _data["error"] !== undefined ? _data["error"] : null;
            this.redirectUrl = _data["redirectUrl"] !== undefined ? _data["redirectUrl"] : null;
        }
    };
    ResponseBaseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResponseBaseModel();
        result.init(data);
        return result;
    };
    ResponseBaseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error !== undefined ? this.error : null;
        data["redirectUrl"] = this.redirectUrl !== undefined ? this.redirectUrl : null;
        return data;
    };
    ResponseBaseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ResponseBaseModel();
        result.init(json);
        return result;
    };
    return ResponseBaseModel;
}());
exports.ResponseBaseModel = ResponseBaseModel;
var AdvertisementMarkAsSeenResponseModel = /** @class */ (function (_super) {
    __extends(AdvertisementMarkAsSeenResponseModel, _super);
    function AdvertisementMarkAsSeenResponseModel(data) {
        return _super.call(this, data) || this;
    }
    AdvertisementMarkAsSeenResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    AdvertisementMarkAsSeenResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertisementMarkAsSeenResponseModel();
        result.init(data);
        return result;
    };
    AdvertisementMarkAsSeenResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdvertisementMarkAsSeenResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertisementMarkAsSeenResponseModel();
        result.init(json);
        return result;
    };
    return AdvertisementMarkAsSeenResponseModel;
}(ResponseBaseModel));
exports.AdvertisementMarkAsSeenResponseModel = AdvertisementMarkAsSeenResponseModel;
var AdvertisementMarkAsSeenRequestModel = /** @class */ (function () {
    function AdvertisementMarkAsSeenRequestModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdvertisementMarkAsSeenRequestModel.prototype.init = function (_data) {
        if (_data) {
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : null;
        }
    };
    AdvertisementMarkAsSeenRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertisementMarkAsSeenRequestModel();
        result.init(data);
        return result;
    };
    AdvertisementMarkAsSeenRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : null;
        return data;
    };
    AdvertisementMarkAsSeenRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertisementMarkAsSeenRequestModel();
        result.init(json);
        return result;
    };
    return AdvertisementMarkAsSeenRequestModel;
}());
exports.AdvertisementMarkAsSeenRequestModel = AdvertisementMarkAsSeenRequestModel;
var DTOBaseModel = /** @class */ (function () {
    function DTOBaseModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DTOBaseModel.prototype.init = function (_data) {
    };
    DTOBaseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOBaseModel();
        result.init(data);
        return result;
    };
    DTOBaseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    DTOBaseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOBaseModel();
        result.init(json);
        return result;
    };
    return DTOBaseModel;
}());
exports.DTOBaseModel = DTOBaseModel;
var DTOAdvertisementCategory = /** @class */ (function (_super) {
    __extends(DTOAdvertisementCategory, _super);
    function DTOAdvertisementCategory(data) {
        return _super.call(this, data) || this;
    }
    DTOAdvertisementCategory.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.advertisementCategoryId = _data["advertisementCategoryId"] !== undefined ? _data["advertisementCategoryId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.code = _data["code"] !== undefined ? _data["code"] : null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : null;
            this.casualDating = _data["casualDating"] !== undefined ? _data["casualDating"] : null;
        }
    };
    DTOAdvertisementCategory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOAdvertisementCategory();
        result.init(data);
        return result;
    };
    DTOAdvertisementCategory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTOAdvertisementCategory.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOAdvertisementCategory();
        result.init(json);
        return result;
    };
    return DTOAdvertisementCategory;
}(DTOBaseModel));
exports.DTOAdvertisementCategory = DTOAdvertisementCategory;
var DTORegion = /** @class */ (function (_super) {
    __extends(DTORegion, _super);
    function DTORegion(data) {
        return _super.call(this, data) || this;
    }
    DTORegion.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null;
            if (Array.isArray(_data["subRegions"])) {
                this.subRegions = [];
                for (var _i = 0, _a = _data["subRegions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.subRegions.push(DTOSubRegion.fromJS(item));
                }
            }
        }
    };
    DTORegion.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTORegion();
        result.init(data);
        return result;
    };
    DTORegion.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null;
        if (Array.isArray(this.subRegions)) {
            data["subRegions"] = [];
            for (var _i = 0, _a = this.subRegions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["subRegions"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTORegion.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTORegion();
        result.init(json);
        return result;
    };
    return DTORegion;
}(DTOBaseModel));
exports.DTORegion = DTORegion;
var DTOSubRegion = /** @class */ (function (_super) {
    __extends(DTOSubRegion, _super);
    function DTOSubRegion(data) {
        return _super.call(this, data) || this;
    }
    DTOSubRegion.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.subRegionId = _data["subRegionId"] !== undefined ? _data["subRegionId"] : null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null;
            this.shortRegionSubregion = _data["shortRegionSubregion"] !== undefined ? _data["shortRegionSubregion"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null;
        }
    };
    DTOSubRegion.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOSubRegion();
        result.init(data);
        return result;
    };
    DTOSubRegion.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null;
        data["shortRegionSubregion"] = this.shortRegionSubregion !== undefined ? this.shortRegionSubregion : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTOSubRegion.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOSubRegion();
        result.init(json);
        return result;
    };
    return DTOSubRegion;
}(DTOBaseModel));
exports.DTOSubRegion = DTOSubRegion;
var AdvertistmentRepostResponse = /** @class */ (function (_super) {
    __extends(AdvertistmentRepostResponse, _super);
    function AdvertistmentRepostResponse(data) {
        return _super.call(this, data) || this;
    }
    AdvertistmentRepostResponse.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.isReposted = _data["isReposted"] !== undefined ? _data["isReposted"] : null;
        }
    };
    AdvertistmentRepostResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertistmentRepostResponse();
        result.init(data);
        return result;
    };
    AdvertistmentRepostResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isReposted"] = this.isReposted !== undefined ? this.isReposted : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdvertistmentRepostResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertistmentRepostResponse();
        result.init(json);
        return result;
    };
    return AdvertistmentRepostResponse;
}(ResponseBaseModel));
exports.AdvertistmentRepostResponse = AdvertistmentRepostResponse;
var DTOAdvertisement = /** @class */ (function (_super) {
    __extends(DTOAdvertisement, _super);
    function DTOAdvertisement(data) {
        return _super.call(this, data) || this;
    }
    DTOAdvertisement.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.seen = _data["seen"] !== undefined ? _data["seen"] : null;
            this.seenAdmin = _data["seenAdmin"] !== undefined ? _data["seenAdmin"] : null;
            this.subRegionId = _data["subRegionId"] !== undefined ? _data["subRegionId"] : null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null;
            this.location = _data["location"] !== undefined ? _data["location"] : null;
            this.dateStart = _data["dateStart"] ? moment(_data["dateStart"].toString()) : null;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.content = _data["content"] !== undefined ? _data["content"] : null;
            this.published = _data["published"] !== undefined ? _data["published"] : null;
            this.casualDating = _data["casualDating"] !== undefined ? _data["casualDating"] : null;
            this.advertisementCategoryId = _data["advertisementCategoryId"] !== undefined ? _data["advertisementCategoryId"] : null;
            this.isPremium = _data["isPremium"] !== undefined ? _data["isPremium"] : null;
            this.isPremiumUser = _data["isPremiumUser"] !== undefined ? _data["isPremiumUser"] : null;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : null;
            this.regionShortName = _data["regionShortName"] !== undefined ? _data["regionShortName"] : null;
            this.subRegionName = _data["subRegionName"] !== undefined ? _data["subRegionName"] : null;
            this.categoryCode = _data["categoryCode"] !== undefined ? _data["categoryCode"] : null;
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (var _i = 0, _a = _data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(DTOAdvertisementImage.fromJS(item));
                }
            }
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.userNick = _data["userNick"] !== undefined ? _data["userNick"] : null;
            this.moderated = _data["moderated"] !== undefined ? _data["moderated"] : null;
            this.moderatedAt = _data["moderatedAt"] ? moment(_data["moderatedAt"].toString()) : null;
            this.moderatedBy = _data["moderatedBy"] !== undefined ? _data["moderatedBy"] : null;
            this.moderateText = _data["moderateText"] !== undefined ? _data["moderateText"] : null;
            this.age = _data["age"] !== undefined ? _data["age"] : null;
            this.locationDescription = _data["locationDescription"] !== undefined ? _data["locationDescription"] : null;
            this.isDemo = _data["isDemo"] !== undefined ? _data["isDemo"] : null;
            this.showAs = _data["showAs"] !== undefined ? _data["showAs"] : null;
        }
    };
    DTOAdvertisement.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOAdvertisement();
        result.init(data);
        return result;
    };
    DTOAdvertisement.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["seen"] = this.seen !== undefined ? this.seen : null;
        data["seenAdmin"] = this.seenAdmin !== undefined ? this.seenAdmin : null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["location"] = this.location !== undefined ? this.location : null;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : null;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["published"] = this.published !== undefined ? this.published : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : null;
        data["isPremiumUser"] = this.isPremiumUser !== undefined ? this.isPremiumUser : null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : null;
        data["regionShortName"] = this.regionShortName !== undefined ? this.regionShortName : null;
        data["subRegionName"] = this.subRegionName !== undefined ? this.subRegionName : null;
        data["categoryCode"] = this.categoryCode !== undefined ? this.categoryCode : null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["userNick"] = this.userNick !== undefined ? this.userNick : null;
        data["moderated"] = this.moderated !== undefined ? this.moderated : null;
        data["moderatedAt"] = this.moderatedAt ? this.moderatedAt.toISOString() : null;
        data["moderatedBy"] = this.moderatedBy !== undefined ? this.moderatedBy : null;
        data["moderateText"] = this.moderateText !== undefined ? this.moderateText : null;
        data["age"] = this.age !== undefined ? this.age : null;
        data["locationDescription"] = this.locationDescription !== undefined ? this.locationDescription : null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : null;
        data["showAs"] = this.showAs !== undefined ? this.showAs : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTOAdvertisement.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOAdvertisement();
        result.init(json);
        return result;
    };
    return DTOAdvertisement;
}(DTOBaseModel));
exports.DTOAdvertisement = DTOAdvertisement;
var AdveristmentCreateModel = /** @class */ (function (_super) {
    __extends(AdveristmentCreateModel, _super);
    function AdveristmentCreateModel(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentCreateModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    AdveristmentCreateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentCreateModel();
        result.init(data);
        return result;
    };
    AdveristmentCreateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentCreateModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentCreateModel();
        result.init(json);
        return result;
    };
    return AdveristmentCreateModel;
}(DTOAdvertisement));
exports.AdveristmentCreateModel = AdveristmentCreateModel;
var AdveristmentUpdateModel = /** @class */ (function (_super) {
    __extends(AdveristmentUpdateModel, _super);
    function AdveristmentUpdateModel(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentUpdateModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.manageId = _data["manageId"] !== undefined ? _data["manageId"] : null;
        }
    };
    AdveristmentUpdateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentUpdateModel();
        result.init(data);
        return result;
    };
    AdveristmentUpdateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["manageId"] = this.manageId !== undefined ? this.manageId : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentUpdateModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentUpdateModel();
        result.init(json);
        return result;
    };
    return AdveristmentUpdateModel;
}(AdveristmentCreateModel));
exports.AdveristmentUpdateModel = AdveristmentUpdateModel;
var AdvertistmentRepostModel = /** @class */ (function (_super) {
    __extends(AdvertistmentRepostModel, _super);
    function AdvertistmentRepostModel(data) {
        return _super.call(this, data) || this;
    }
    AdvertistmentRepostModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    AdvertistmentRepostModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertistmentRepostModel();
        result.init(data);
        return result;
    };
    AdvertistmentRepostModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdvertistmentRepostModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertistmentRepostModel();
        result.init(json);
        return result;
    };
    return AdvertistmentRepostModel;
}(AdveristmentUpdateModel));
exports.AdvertistmentRepostModel = AdvertistmentRepostModel;
var DTOAdvertisementImage = /** @class */ (function (_super) {
    __extends(DTOAdvertisementImage, _super);
    function DTOAdvertisementImage(data) {
        return _super.call(this, data) || this;
    }
    DTOAdvertisementImage.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.advertisementImageId = _data["advertisementImageId"] !== undefined ? _data["advertisementImageId"] : null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.orgFileName = _data["orgFileName"] !== undefined ? _data["orgFileName"] : null;
            this.tempFileName = _data["tempFileName"] !== undefined ? _data["tempFileName"] : null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : null;
            this.isMain = _data["isMain"] !== undefined ? _data["isMain"] : null;
        }
    };
    DTOAdvertisementImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOAdvertisementImage();
        result.init(data);
        return result;
    };
    DTOAdvertisementImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementImageId"] = this.advertisementImageId !== undefined ? this.advertisementImageId : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : null;
        data["tempFileName"] = this.tempFileName !== undefined ? this.tempFileName : null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null;
        data["isMain"] = this.isMain !== undefined ? this.isMain : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTOAdvertisementImage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOAdvertisementImage();
        result.init(json);
        return result;
    };
    return DTOAdvertisementImage;
}(DTOBaseModel));
exports.DTOAdvertisementImage = DTOAdvertisementImage;
var ShowAdType;
(function (ShowAdType) {
    ShowAdType[ShowAdType["NotSet"] = 0] = "NotSet";
    ShowAdType[ShowAdType["PremiumAd"] = 1] = "PremiumAd";
    ShowAdType[ShowAdType["PremiumUser"] = 2] = "PremiumUser";
    ShowAdType[ShowAdType["StandardAd"] = 3] = "StandardAd";
})(ShowAdType = exports.ShowAdType || (exports.ShowAdType = {}));
var AdveristmentCreateResponse = /** @class */ (function (_super) {
    __extends(AdveristmentCreateResponse, _super);
    function AdveristmentCreateResponse(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentCreateResponse.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
        }
    };
    AdveristmentCreateResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentCreateResponse();
        result.init(data);
        return result;
    };
    AdveristmentCreateResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentCreateResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentCreateResponse();
        result.init(json);
        return result;
    };
    return AdveristmentCreateResponse;
}(ResponseBaseModel));
exports.AdveristmentCreateResponse = AdveristmentCreateResponse;
var AdveristmentUpdateResponse = /** @class */ (function (_super) {
    __extends(AdveristmentUpdateResponse, _super);
    function AdveristmentUpdateResponse(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentUpdateResponse.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    AdveristmentUpdateResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentUpdateResponse();
        result.init(data);
        return result;
    };
    AdveristmentUpdateResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentUpdateResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentUpdateResponse();
        result.init(json);
        return result;
    };
    return AdveristmentUpdateResponse;
}(AdveristmentCreateResponse));
exports.AdveristmentUpdateResponse = AdveristmentUpdateResponse;
var AdveristmentDeleteResponse = /** @class */ (function (_super) {
    __extends(AdveristmentDeleteResponse, _super);
    function AdveristmentDeleteResponse(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentDeleteResponse.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    AdveristmentDeleteResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentDeleteResponse();
        result.init(data);
        return result;
    };
    AdveristmentDeleteResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentDeleteResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentDeleteResponse();
        result.init(json);
        return result;
    };
    return AdveristmentDeleteResponse;
}(AdveristmentCreateResponse));
exports.AdveristmentDeleteResponse = AdveristmentDeleteResponse;
var AdveristmentDeleteModel = /** @class */ (function () {
    function AdveristmentDeleteModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdveristmentDeleteModel.prototype.init = function (_data) {
        if (_data) {
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
        }
    };
    AdveristmentDeleteModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentDeleteModel();
        result.init(data);
        return result;
    };
    AdveristmentDeleteModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        return data;
    };
    AdveristmentDeleteModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentDeleteModel();
        result.init(json);
        return result;
    };
    return AdveristmentDeleteModel;
}());
exports.AdveristmentDeleteModel = AdveristmentDeleteModel;
var AdveristmentGetResponse = /** @class */ (function (_super) {
    __extends(AdveristmentGetResponse, _super);
    function AdveristmentGetResponse(data) {
        return _super.call(this, data) || this;
    }
    AdveristmentGetResponse.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            if (Array.isArray(_data["adveristments"])) {
                this.adveristments = [];
                for (var _i = 0, _a = _data["adveristments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.adveristments.push(DTOAdvertisement.fromJS(item));
                }
            }
            this.totalResultsCount = _data["totalResultsCount"] !== undefined ? _data["totalResultsCount"] : null;
            this.regionShortName = _data["regionShortName"] !== undefined ? _data["regionShortName"] : null;
            this.subRegionName = _data["subRegionName"] !== undefined ? _data["subRegionName"] : null;
            this.closestSubregionNameIfNoResult = _data["closestSubregionNameIfNoResult"] !== undefined ? _data["closestSubregionNameIfNoResult"] : null;
        }
    };
    AdveristmentGetResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentGetResponse();
        result.init(data);
        return result;
    };
    AdveristmentGetResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.adveristments)) {
            data["adveristments"] = [];
            for (var _i = 0, _a = this.adveristments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["adveristments"].push(item.toJSON());
            }
        }
        data["totalResultsCount"] = this.totalResultsCount !== undefined ? this.totalResultsCount : null;
        data["regionShortName"] = this.regionShortName !== undefined ? this.regionShortName : null;
        data["subRegionName"] = this.subRegionName !== undefined ? this.subRegionName : null;
        data["closestSubregionNameIfNoResult"] = this.closestSubregionNameIfNoResult !== undefined ? this.closestSubregionNameIfNoResult : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdveristmentGetResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentGetResponse();
        result.init(json);
        return result;
    };
    return AdveristmentGetResponse;
}(ResponseBaseModel));
exports.AdveristmentGetResponse = AdveristmentGetResponse;
var AdveristmentGetModel = /** @class */ (function () {
    function AdveristmentGetModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdveristmentGetModel.prototype.init = function (_data) {
        if (_data) {
            this.byId = _data["byId"] !== undefined ? _data["byId"] : null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null;
            this.nonDemoOnly = _data["nonDemoOnly"] !== undefined ? _data["nonDemoOnly"] : null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.subRegionId = _data["subRegionId"] !== undefined ? _data["subRegionId"] : null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null;
            this.miles = _data["miles"] !== undefined ? _data["miles"] : null;
            this.keywords = _data["keywords"] !== undefined ? _data["keywords"] : null;
            this.withPicturesOnly = _data["withPicturesOnly"] !== undefined ? _data["withPicturesOnly"] : null;
            this.showActive = _data["showActive"] !== undefined ? _data["showActive"] : null;
            this.showExpired = _data["showExpired"] !== undefined ? _data["showExpired"] : null;
            this.casualDating = _data["casualDating"] !== undefined ? _data["casualDating"] : null;
            this.advertisementCategoryId = _data["advertisementCategoryId"] !== undefined ? _data["advertisementCategoryId"] : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.content = _data["content"] !== undefined ? _data["content"] : null;
            this.manageId = _data["manageId"] !== undefined ? _data["manageId"] : null;
            this.age = _data["age"] !== undefined ? _data["age"] : null;
            this.locationDescription = _data["locationDescription"] !== undefined ? _data["locationDescription"] : null;
        }
    };
    AdveristmentGetModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdveristmentGetModel();
        result.init(data);
        return result;
    };
    AdveristmentGetModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["byId"] = this.byId !== undefined ? this.byId : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null;
        data["nonDemoOnly"] = this.nonDemoOnly !== undefined ? this.nonDemoOnly : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["miles"] = this.miles !== undefined ? this.miles : null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : null;
        data["withPicturesOnly"] = this.withPicturesOnly !== undefined ? this.withPicturesOnly : null;
        data["showActive"] = this.showActive !== undefined ? this.showActive : null;
        data["showExpired"] = this.showExpired !== undefined ? this.showExpired : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["manageId"] = this.manageId !== undefined ? this.manageId : null;
        data["age"] = this.age !== undefined ? this.age : null;
        data["locationDescription"] = this.locationDescription !== undefined ? this.locationDescription : null;
        return data;
    };
    AdveristmentGetModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdveristmentGetModel();
        result.init(json);
        return result;
    };
    return AdveristmentGetModel;
}());
exports.AdveristmentGetModel = AdveristmentGetModel;
var AdWritterInformationResponse = /** @class */ (function (_super) {
    __extends(AdWritterInformationResponse, _super);
    function AdWritterInformationResponse(data) {
        return _super.call(this, data) || this;
    }
    AdWritterInformationResponse.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.isSend = _data["isSend"] !== undefined ? _data["isSend"] : null;
        }
    };
    AdWritterInformationResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdWritterInformationResponse();
        result.init(data);
        return result;
    };
    AdWritterInformationResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isSend"] = this.isSend !== undefined ? this.isSend : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdWritterInformationResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdWritterInformationResponse();
        result.init(json);
        return result;
    };
    return AdWritterInformationResponse;
}(ResponseBaseModel));
exports.AdWritterInformationResponse = AdWritterInformationResponse;
var AdWritterInformationRequest = /** @class */ (function () {
    function AdWritterInformationRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdWritterInformationRequest.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.age = _data["age"] !== undefined ? _data["age"] : null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : null;
            this.lookingFor = _data["lookingFor"] !== undefined ? _data["lookingFor"] : null;
            this.height = _data["height"] !== undefined ? _data["height"] : null;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : null;
            this.bodyType = _data["bodyType"] !== undefined ? _data["bodyType"] : null;
            this.race = _data["race"] !== undefined ? _data["race"] : null;
            this.idealMatch = _data["idealMatch"] !== undefined ? _data["idealMatch"] : null;
            this.lookingForRelationship = _data["lookingForRelationship"] !== undefined ? _data["lookingForRelationship"] : null;
            this.thingsInFreeTime = _data["thingsInFreeTime"] !== undefined ? _data["thingsInFreeTime"] : null;
            this.aspectsOfLife = _data["aspectsOfLife"] !== undefined ? _data["aspectsOfLife"] : null;
            this.dontLike = _data["dontLike"] !== undefined ? _data["dontLike"] : null;
            this.passions = _data["passions"] !== undefined ? _data["passions"] : null;
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : null;
            this.characteristics = _data["characteristics"] !== undefined ? _data["characteristics"] : null;
            this.goalsAndDreams = _data["goalsAndDreams"] !== undefined ? _data["goalsAndDreams"] : null;
            this.thankfullFor = _data["thankfullFor"] !== undefined ? _data["thankfullFor"] : null;
            this.kids = _data["kids"] !== undefined ? _data["kids"] : null;
            this.education = _data["education"] !== undefined ? _data["education"] : null;
            this.workout = _data["workout"] !== undefined ? _data["workout"] : null;
            this.travel = _data["travel"] !== undefined ? _data["travel"] : null;
            this.healthyFood = _data["healthyFood"] !== undefined ? _data["healthyFood"] : null;
            this.smoke = _data["smoke"] !== undefined ? _data["smoke"] : null;
            this.alcohol = _data["alcohol"] !== undefined ? _data["alcohol"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
        }
    };
    AdWritterInformationRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdWritterInformationRequest();
        result.init(data);
        return result;
    };
    AdWritterInformationRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["age"] = this.age !== undefined ? this.age : null;
        data["gender"] = this.gender !== undefined ? this.gender : null;
        data["lookingFor"] = this.lookingFor !== undefined ? this.lookingFor : null;
        data["height"] = this.height !== undefined ? this.height : null;
        data["weight"] = this.weight !== undefined ? this.weight : null;
        data["bodyType"] = this.bodyType !== undefined ? this.bodyType : null;
        data["race"] = this.race !== undefined ? this.race : null;
        data["idealMatch"] = this.idealMatch !== undefined ? this.idealMatch : null;
        data["lookingForRelationship"] = this.lookingForRelationship !== undefined ? this.lookingForRelationship : null;
        data["thingsInFreeTime"] = this.thingsInFreeTime !== undefined ? this.thingsInFreeTime : null;
        data["aspectsOfLife"] = this.aspectsOfLife !== undefined ? this.aspectsOfLife : null;
        data["dontLike"] = this.dontLike !== undefined ? this.dontLike : null;
        data["passions"] = this.passions !== undefined ? this.passions : null;
        data["occupation"] = this.occupation !== undefined ? this.occupation : null;
        data["characteristics"] = this.characteristics !== undefined ? this.characteristics : null;
        data["goalsAndDreams"] = this.goalsAndDreams !== undefined ? this.goalsAndDreams : null;
        data["thankfullFor"] = this.thankfullFor !== undefined ? this.thankfullFor : null;
        data["kids"] = this.kids !== undefined ? this.kids : null;
        data["education"] = this.education !== undefined ? this.education : null;
        data["workout"] = this.workout !== undefined ? this.workout : null;
        data["travel"] = this.travel !== undefined ? this.travel : null;
        data["healthyFood"] = this.healthyFood !== undefined ? this.healthyFood : null;
        data["smoke"] = this.smoke !== undefined ? this.smoke : null;
        data["alcohol"] = this.alcohol !== undefined ? this.alcohol : null;
        data["email"] = this.email !== undefined ? this.email : null;
        return data;
    };
    AdWritterInformationRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdWritterInformationRequest();
        result.init(json);
        return result;
    };
    return AdWritterInformationRequest;
}());
exports.AdWritterInformationRequest = AdWritterInformationRequest;
var LoginResponseModel = /** @class */ (function (_super) {
    __extends(LoginResponseModel, _super);
    function LoginResponseModel(data) {
        return _super.call(this, data) || this;
    }
    LoginResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : null;
            this.isDemo = _data["isDemo"] !== undefined ? _data["isDemo"] : null;
            this.phoneVerificationRequired = _data["phoneVerificationRequired"] !== undefined ? _data["phoneVerificationRequired"] : null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.userPhone = _data["userPhone"] !== undefined ? _data["userPhone"] : null;
        }
    };
    LoginResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoginResponseModel();
        result.init(data);
        return result;
    };
    LoginResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : null;
        data["phoneVerificationRequired"] = this.phoneVerificationRequired !== undefined ? this.phoneVerificationRequired : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["userPhone"] = this.userPhone !== undefined ? this.userPhone : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    LoginResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LoginResponseModel();
        result.init(json);
        return result;
    };
    return LoginResponseModel;
}(ResponseBaseModel));
exports.LoginResponseModel = LoginResponseModel;
var LoginModel = /** @class */ (function () {
    function LoginModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LoginModel.prototype.init = function (_data) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null;
            this.password = _data["password"] !== undefined ? _data["password"] : null;
        }
    };
    LoginModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LoginModel();
        result.init(data);
        return result;
    };
    LoginModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["password"] = this.password !== undefined ? this.password : null;
        return data;
    };
    LoginModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LoginModel();
        result.init(json);
        return result;
    };
    return LoginModel;
}());
exports.LoginModel = LoginModel;
var ConversationDeleteResponseModel = /** @class */ (function (_super) {
    __extends(ConversationDeleteResponseModel, _super);
    function ConversationDeleteResponseModel(data) {
        return _super.call(this, data) || this;
    }
    ConversationDeleteResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    ConversationDeleteResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationDeleteResponseModel();
        result.init(data);
        return result;
    };
    ConversationDeleteResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    ConversationDeleteResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationDeleteResponseModel();
        result.init(json);
        return result;
    };
    return ConversationDeleteResponseModel;
}(ResponseBaseModel));
exports.ConversationDeleteResponseModel = ConversationDeleteResponseModel;
var ConversationDeleteRequestModel = /** @class */ (function () {
    function ConversationDeleteRequestModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConversationDeleteRequestModel.prototype.init = function (_data) {
        if (_data) {
            this.conversationId = _data["conversationId"] !== undefined ? _data["conversationId"] : null;
        }
    };
    ConversationDeleteRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationDeleteRequestModel();
        result.init(data);
        return result;
    };
    ConversationDeleteRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : null;
        return data;
    };
    ConversationDeleteRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationDeleteRequestModel();
        result.init(json);
        return result;
    };
    return ConversationDeleteRequestModel;
}());
exports.ConversationDeleteRequestModel = ConversationDeleteRequestModel;
var GetConversationResponseModel = /** @class */ (function (_super) {
    __extends(GetConversationResponseModel, _super);
    function GetConversationResponseModel(data) {
        return _super.call(this, data) || this;
    }
    GetConversationResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.conversation = _data["conversation"] ? DTOConversation.fromJS(_data["conversation"]) : null;
        }
    };
    GetConversationResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetConversationResponseModel();
        result.init(data);
        return result;
    };
    GetConversationResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversation"] = this.conversation ? this.conversation.toJSON() : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    GetConversationResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GetConversationResponseModel();
        result.init(json);
        return result;
    };
    return GetConversationResponseModel;
}(ResponseBaseModel));
exports.GetConversationResponseModel = GetConversationResponseModel;
var DTOConversation = /** @class */ (function () {
    function DTOConversation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DTOConversation.prototype.init = function (_data) {
        if (_data) {
            this.conversationId = _data["conversationId"] !== undefined ? _data["conversationId"] : null;
            this.senderId = _data["senderId"] !== undefined ? _data["senderId"] : null;
            this.receiverId = _data["receiverId"] !== undefined ? _data["receiverId"] : null;
            this.conversationKey = _data["conversationKey"] !== undefined ? _data["conversationKey"] : null;
            this.senderNick = _data["senderNick"] !== undefined ? _data["senderNick"] : null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
            this.receiverNick = _data["receiverNick"] !== undefined ? _data["receiverNick"] : null;
            this.advTitle = _data["advTitle"] !== undefined ? _data["advTitle"] : null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
            this.demoAdvertisement = _data["demoAdvertisement"] !== undefined ? _data["demoAdvertisement"] : null;
            this.hasNewMessages = _data["hasNewMessages"] !== undefined ? _data["hasNewMessages"] : null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [];
                for (var _i = 0, _a = _data["messages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.messages.push(DTOConversationMessage.fromJS(item));
                }
            }
        }
    };
    DTOConversation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOConversation();
        result.init(data);
        return result;
    };
    DTOConversation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : null;
        data["receiverId"] = this.receiverId !== undefined ? this.receiverId : null;
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["receiverNick"] = this.receiverNick !== undefined ? this.receiverNick : null;
        data["advTitle"] = this.advTitle !== undefined ? this.advTitle : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["demoAdvertisement"] = this.demoAdvertisement !== undefined ? this.demoAdvertisement : null;
        data["hasNewMessages"] = this.hasNewMessages !== undefined ? this.hasNewMessages : null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (var _i = 0, _a = this.messages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["messages"].push(item.toJSON());
            }
        }
        return data;
    };
    DTOConversation.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOConversation();
        result.init(json);
        return result;
    };
    return DTOConversation;
}());
exports.DTOConversation = DTOConversation;
var DTOConversationMessage = /** @class */ (function () {
    function DTOConversationMessage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DTOConversationMessage.prototype.init = function (_data) {
        if (_data) {
            this.conversationMessageId = _data["conversationMessageId"] !== undefined ? _data["conversationMessageId"] : null;
            this.content = _data["content"] !== undefined ? _data["content"] : null;
            this.senderId = _data["senderId"] !== undefined ? _data["senderId"] : null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.isRead = _data["isRead"] !== undefined ? _data["isRead"] : null;
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (var _i = 0, _a = _data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(DTOConversationImage.fromJS(item));
                }
            }
        }
    };
    DTOConversationMessage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOConversationMessage();
        result.init(data);
        return result;
    };
    DTOConversationMessage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationMessageId"] = this.conversationMessageId !== undefined ? this.conversationMessageId : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["isRead"] = this.isRead !== undefined ? this.isRead : null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        return data;
    };
    DTOConversationMessage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOConversationMessage();
        result.init(json);
        return result;
    };
    return DTOConversationMessage;
}());
exports.DTOConversationMessage = DTOConversationMessage;
var DTOConversationImage = /** @class */ (function () {
    function DTOConversationImage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DTOConversationImage.prototype.init = function (_data) {
        if (_data) {
            this.conversationImageId = _data["conversationImageId"] !== undefined ? _data["conversationImageId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
        }
    };
    DTOConversationImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOConversationImage();
        result.init(data);
        return result;
    };
    DTOConversationImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationImageId"] = this.conversationImageId !== undefined ? this.conversationImageId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        return data;
    };
    DTOConversationImage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOConversationImage();
        result.init(json);
        return result;
    };
    return DTOConversationImage;
}());
exports.DTOConversationImage = DTOConversationImage;
var UserConversationsResponseModel = /** @class */ (function (_super) {
    __extends(UserConversationsResponseModel, _super);
    function UserConversationsResponseModel(data) {
        return _super.call(this, data) || this;
    }
    UserConversationsResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            if (Array.isArray(_data["conversations"])) {
                this.conversations = [];
                for (var _i = 0, _a = _data["conversations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.conversations.push(DTOConversation.fromJS(item));
                }
            }
        }
    };
    UserConversationsResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserConversationsResponseModel();
        result.init(data);
        return result;
    };
    UserConversationsResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conversations)) {
            data["conversations"] = [];
            for (var _i = 0, _a = this.conversations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["conversations"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    UserConversationsResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UserConversationsResponseModel();
        result.init(json);
        return result;
    };
    return UserConversationsResponseModel;
}(ResponseBaseModel));
exports.UserConversationsResponseModel = UserConversationsResponseModel;
var UserConversationsRequestModel = /** @class */ (function () {
    function UserConversationsRequestModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserConversationsRequestModel.prototype.init = function (_data) {
    };
    UserConversationsRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserConversationsRequestModel();
        result.init(data);
        return result;
    };
    UserConversationsRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    UserConversationsRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UserConversationsRequestModel();
        result.init(json);
        return result;
    };
    return UserConversationsRequestModel;
}());
exports.UserConversationsRequestModel = UserConversationsRequestModel;
var MessageSubmitResponseModel = /** @class */ (function (_super) {
    __extends(MessageSubmitResponseModel, _super);
    function MessageSubmitResponseModel(data) {
        return _super.call(this, data) || this;
    }
    MessageSubmitResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.conversationKey = _data["conversationKey"] !== undefined ? _data["conversationKey"] : null;
        }
    };
    MessageSubmitResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MessageSubmitResponseModel();
        result.init(data);
        return result;
    };
    MessageSubmitResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    MessageSubmitResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new MessageSubmitResponseModel();
        result.init(json);
        return result;
    };
    return MessageSubmitResponseModel;
}(ResponseBaseModel));
exports.MessageSubmitResponseModel = MessageSubmitResponseModel;
var BaseMessageSubmitRequestModel = /** @class */ (function () {
    function BaseMessageSubmitRequestModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaseMessageSubmitRequestModel.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (var _i = 0, _a = _data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(DTOImage.fromJS(item));
                }
            }
            this.content = _data["content"] !== undefined ? _data["content"] : null;
        }
    };
    BaseMessageSubmitRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BaseMessageSubmitRequestModel();
        result.init(data);
        return result;
    };
    BaseMessageSubmitRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["content"] = this.content !== undefined ? this.content : null;
        return data;
    };
    BaseMessageSubmitRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new BaseMessageSubmitRequestModel();
        result.init(json);
        return result;
    };
    return BaseMessageSubmitRequestModel;
}());
exports.BaseMessageSubmitRequestModel = BaseMessageSubmitRequestModel;
var ConversationMessageSubmitRequestModel = /** @class */ (function (_super) {
    __extends(ConversationMessageSubmitRequestModel, _super);
    function ConversationMessageSubmitRequestModel(data) {
        return _super.call(this, data) || this;
    }
    ConversationMessageSubmitRequestModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.conversationId = _data["conversationId"] !== undefined ? _data["conversationId"] : null;
            this.senderId = _data["senderId"] !== undefined ? _data["senderId"] : null;
        }
    };
    ConversationMessageSubmitRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationMessageSubmitRequestModel();
        result.init(data);
        return result;
    };
    ConversationMessageSubmitRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    ConversationMessageSubmitRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationMessageSubmitRequestModel();
        result.init(json);
        return result;
    };
    return ConversationMessageSubmitRequestModel;
}(BaseMessageSubmitRequestModel));
exports.ConversationMessageSubmitRequestModel = ConversationMessageSubmitRequestModel;
var DTOImage = /** @class */ (function (_super) {
    __extends(DTOImage, _super);
    function DTOImage(data) {
        return _super.call(this, data) || this;
    }
    DTOImage.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.orgFileName = _data["orgFileName"] !== undefined ? _data["orgFileName"] : null;
        }
    };
    DTOImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOImage();
        result.init(data);
        return result;
    };
    DTOImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    DTOImage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOImage();
        result.init(json);
        return result;
    };
    return DTOImage;
}(DTOBaseModel));
exports.DTOImage = DTOImage;
var StartConversationMessageSubmitRequestModel = /** @class */ (function (_super) {
    __extends(StartConversationMessageSubmitRequestModel, _super);
    function StartConversationMessageSubmitRequestModel(data) {
        return _super.call(this, data) || this;
    }
    StartConversationMessageSubmitRequestModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.receiverId = _data["receiverId"] !== undefined ? _data["receiverId"] : null;
            this.senderId = _data["senderId"] !== undefined ? _data["senderId"] : null;
            this.senderNick = _data["senderNick"] !== undefined ? _data["senderNick"] : null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
        }
    };
    StartConversationMessageSubmitRequestModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StartConversationMessageSubmitRequestModel();
        result.init(data);
        return result;
    };
    StartConversationMessageSubmitRequestModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["receiverId"] = this.receiverId !== undefined ? this.receiverId : null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    StartConversationMessageSubmitRequestModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StartConversationMessageSubmitRequestModel();
        result.init(json);
        return result;
    };
    return StartConversationMessageSubmitRequestModel;
}(BaseMessageSubmitRequestModel));
exports.StartConversationMessageSubmitRequestModel = StartConversationMessageSubmitRequestModel;
var EmojiResponseModel = /** @class */ (function (_super) {
    __extends(EmojiResponseModel, _super);
    function EmojiResponseModel(data) {
        return _super.call(this, data) || this;
    }
    EmojiResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            if (Array.isArray(_data["emojis"])) {
                this.emojis = [];
                for (var _i = 0, _a = _data["emojis"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.emojis.push(DTOEmoji.fromJS(item));
                }
            }
        }
    };
    EmojiResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EmojiResponseModel();
        result.init(data);
        return result;
    };
    EmojiResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emojis)) {
            data["emojis"] = [];
            for (var _i = 0, _a = this.emojis; _i < _a.length; _i++) {
                var item = _a[_i];
                data["emojis"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    EmojiResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new EmojiResponseModel();
        result.init(json);
        return result;
    };
    return EmojiResponseModel;
}(ResponseBaseModel));
exports.EmojiResponseModel = EmojiResponseModel;
var DTOEmoji = /** @class */ (function () {
    function DTOEmoji(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DTOEmoji.prototype.init = function (_data) {
        if (_data) {
            this.emojiId = _data["emojiId"] !== undefined ? _data["emojiId"] : null;
            this.code = _data["code"] !== undefined ? _data["code"] : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.category = _data["category"] !== undefined ? _data["category"] : null;
        }
    };
    DTOEmoji.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DTOEmoji();
        result.init(data);
        return result;
    };
    DTOEmoji.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emojiId"] = this.emojiId !== undefined ? this.emojiId : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["category"] = this.category !== undefined ? this.category : null;
        return data;
    };
    DTOEmoji.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DTOEmoji();
        result.init(json);
        return result;
    };
    return DTOEmoji;
}());
exports.DTOEmoji = DTOEmoji;
var BaseModel = /** @class */ (function () {
    function BaseModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BaseModel.prototype.init = function (_data) {
        if (_data) {
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : null;
            this.updatedAt = _data["updatedAt"] ? moment(_data["updatedAt"].toString()) : null;
            this.createdById = _data["createdById"] !== undefined ? _data["createdById"] : null;
            this.updatedById = _data["updatedById"] !== undefined ? _data["updatedById"] : null;
        }
    };
    BaseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BaseModel();
        result.init(data);
        return result;
    };
    BaseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null;
        data["createdById"] = this.createdById !== undefined ? this.createdById : null;
        data["updatedById"] = this.updatedById !== undefined ? this.updatedById : null;
        return data;
    };
    BaseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new BaseModel();
        result.init(json);
        return result;
    };
    return BaseModel;
}());
exports.BaseModel = BaseModel;
var SubRegion = /** @class */ (function (_super) {
    __extends(SubRegion, _super);
    function SubRegion(data) {
        return _super.call(this, data) || this;
    }
    SubRegion.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.subRegionId = _data["subRegionId"] !== undefined ? _data["subRegionId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.demoQuantityRatio = _data["demoQuantityRatio"] !== undefined ? _data["demoQuantityRatio"] : null;
            this.population = _data["population"] !== undefined ? _data["population"] : null;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : null;
            if (Array.isArray(_data["advertisements"])) {
                this.advertisements = [];
                for (var _i = 0, _a = _data["advertisements"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.advertisements.push(Advertisement.fromJS(item));
                }
            }
        }
    };
    SubRegion.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubRegion();
        result.init(data);
        return result;
    };
    SubRegion.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["demoQuantityRatio"] = this.demoQuantityRatio !== undefined ? this.demoQuantityRatio : null;
        data["population"] = this.population !== undefined ? this.population : null;
        data["region"] = this.region ? this.region.toJSON() : null;
        if (Array.isArray(this.advertisements)) {
            data["advertisements"] = [];
            for (var _i = 0, _a = this.advertisements; _i < _a.length; _i++) {
                var item = _a[_i];
                data["advertisements"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    SubRegion.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SubRegion();
        result.init(json);
        return result;
    };
    return SubRegion;
}(BaseModel));
exports.SubRegion = SubRegion;
var Region = /** @class */ (function (_super) {
    __extends(Region, _super);
    function Region(data) {
        return _super.call(this, data) || this;
    }
    Region.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null;
            if (Array.isArray(_data["subRegions"])) {
                this.subRegions = [];
                for (var _i = 0, _a = _data["subRegions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.subRegions.push(SubRegion.fromJS(item));
                }
            }
            if (Array.isArray(_data["advertisements"])) {
                this.advertisements = [];
                for (var _b = 0, _c = _data["advertisements"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.advertisements.push(Advertisement.fromJS(item));
                }
            }
        }
    };
    Region.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Region();
        result.init(data);
        return result;
    };
    Region.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null;
        if (Array.isArray(this.subRegions)) {
            data["subRegions"] = [];
            for (var _i = 0, _a = this.subRegions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["subRegions"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.advertisements)) {
            data["advertisements"] = [];
            for (var _b = 0, _c = this.advertisements; _b < _c.length; _b++) {
                var item = _c[_b];
                data["advertisements"].push(item.toJSON());
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    Region.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Region();
        result.init(json);
        return result;
    };
    return Region;
}(BaseModel));
exports.Region = Region;
var Advertisement = /** @class */ (function (_super) {
    __extends(Advertisement, _super);
    function Advertisement(data) {
        return _super.call(this, data) || this;
    }
    Advertisement.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null;
            this.subRegionId = _data["subRegionId"] !== undefined ? _data["subRegionId"] : null;
            this.seen = _data["seen"] !== undefined ? _data["seen"] : null;
            this.seenAdmin = _data["seenAdmin"] !== undefined ? _data["seenAdmin"] : null;
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : null;
            this.subRegion = _data["subRegion"] ? SubRegion.fromJS(_data["subRegion"]) : null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null;
            this.location = _data["location"] ? Point.fromJS(_data["location"]) : null;
            this.dateStart = _data["dateStart"] ? moment(_data["dateStart"].toString()) : null;
            this.dateEnd = _data["dateEnd"] ? moment(_data["dateEnd"].toString()) : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.content = _data["content"] !== undefined ? _data["content"] : null;
            this.published = _data["published"] !== undefined ? _data["published"] : null;
            this.casualDating = _data["casualDating"] !== undefined ? _data["casualDating"] : null;
            this.advertisementCategoryId = _data["advertisementCategoryId"] !== undefined ? _data["advertisementCategoryId"] : null;
            this.nick = _data["nick"] !== undefined ? _data["nick"] : null;
            this.category = _data["category"] ? AdvertisementCategory.fromJS(_data["category"]) : null;
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (var _i = 0, _a = _data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(AdvertisementImage.fromJS(item));
                }
            }
            if (Array.isArray(_data["conversations"])) {
                this.conversations = [];
                for (var _b = 0, _c = _data["conversations"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.conversations.push(Conversation.fromJS(item));
                }
            }
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.isDemo = _data["isDemo"] !== undefined ? _data["isDemo"] : null;
            this.isPremium = _data["isPremium"] !== undefined ? _data["isPremium"] : null;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : null;
            this.manageId = _data["manageId"] !== undefined ? _data["manageId"] : null;
            this.moderated = _data["moderated"] !== undefined ? _data["moderated"] : null;
            this.moderatedAt = _data["moderatedAt"] ? moment(_data["moderatedAt"].toString()) : null;
            this.moderatedBy = _data["moderatedBy"] !== undefined ? _data["moderatedBy"] : null;
            this.moderateText = _data["moderateText"] !== undefined ? _data["moderateText"] : null;
            this.age = _data["age"] !== undefined ? _data["age"] : null;
            this.settings = _data["settings"] ? AdvertisementSetting.fromJS(_data["settings"]) : null;
        }
    };
    Advertisement.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Advertisement();
        result.init(data);
        return result;
    };
    Advertisement.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : null;
        data["seen"] = this.seen !== undefined ? this.seen : null;
        data["seenAdmin"] = this.seenAdmin !== undefined ? this.seenAdmin : null;
        data["region"] = this.region ? this.region.toJSON() : null;
        data["subRegion"] = this.subRegion ? this.subRegion.toJSON() : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["location"] = this.location ? this.location.toJSON() : null;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : null;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["published"] = this.published !== undefined ? this.published : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : null;
        data["nick"] = this.nick !== undefined ? this.nick : null;
        data["category"] = this.category ? this.category.toJSON() : null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.conversations)) {
            data["conversations"] = [];
            for (var _b = 0, _c = this.conversations; _b < _c.length; _b++) {
                var item = _c[_b];
                data["conversations"].push(item.toJSON());
            }
        }
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : null;
        data["user"] = this.user ? this.user.toJSON() : null;
        data["manageId"] = this.manageId !== undefined ? this.manageId : null;
        data["moderated"] = this.moderated !== undefined ? this.moderated : null;
        data["moderatedAt"] = this.moderatedAt ? this.moderatedAt.toISOString() : null;
        data["moderatedBy"] = this.moderatedBy !== undefined ? this.moderatedBy : null;
        data["moderateText"] = this.moderateText !== undefined ? this.moderateText : null;
        data["age"] = this.age !== undefined ? this.age : null;
        data["settings"] = this.settings ? this.settings.toJSON() : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    Advertisement.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Advertisement();
        result.init(json);
        return result;
    };
    return Advertisement;
}(BaseModel));
exports.Advertisement = Advertisement;
var Geometry = /** @class */ (function () {
    function Geometry(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Geometry.prototype.init = function (_data) {
        if (_data) {
            this.factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : null;
            this.userData = _data["userData"] !== undefined ? _data["userData"] : null;
            this.srid = _data["srid"] !== undefined ? _data["srid"] : null;
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : null;
            this.numGeometries = _data["numGeometries"] !== undefined ? _data["numGeometries"] : null;
            this.isSimple = _data["isSimple"] !== undefined ? _data["isSimple"] : null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : null;
            this.area = _data["area"] !== undefined ? _data["area"] : null;
            this.length = _data["length"] !== undefined ? _data["length"] : null;
            this.centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : null;
            this.interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : null;
            this.pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : null;
            this.envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : null;
            this.envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : null;
            this.isRectangle = _data["isRectangle"] !== undefined ? _data["isRectangle"] : null;
        }
    };
    Geometry.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Geometry' cannot be instantiated.");
    };
    Geometry.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : null;
        data["userData"] = this.userData !== undefined ? this.userData : null;
        data["srid"] = this.srid !== undefined ? this.srid : null;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : null;
        data["numGeometries"] = this.numGeometries !== undefined ? this.numGeometries : null;
        data["isSimple"] = this.isSimple !== undefined ? this.isSimple : null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : null;
        data["area"] = this.area !== undefined ? this.area : null;
        data["length"] = this.length !== undefined ? this.length : null;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : null;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : null;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : null;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : null;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : null;
        data["isRectangle"] = this.isRectangle !== undefined ? this.isRectangle : null;
        return data;
    };
    Geometry.prototype.clone = function () {
        throw new Error("The abstract class 'Geometry' cannot be instantiated.");
    };
    return Geometry;
}());
exports.Geometry = Geometry;
var Point = /** @class */ (function (_super) {
    __extends(Point, _super);
    function Point(data) {
        return _super.call(this, data) || this;
    }
    Point.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.coordinateSequence = _data["coordinateSequence"] ? CoordinateSequence.fromJS(_data["coordinateSequence"]) : null;
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [];
                for (var _i = 0, _a = _data["coordinates"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.coordinates.push(Coordinate.fromJS(item));
                }
            }
            this.numPoints = _data["numPoints"] !== undefined ? _data["numPoints"] : null;
            this.isEmpty = _data["isEmpty"] !== undefined ? _data["isEmpty"] : null;
            this.dimension = _data["dimension"] !== undefined ? _data["dimension"] : null;
            this.boundaryDimension = _data["boundaryDimension"] !== undefined ? _data["boundaryDimension"] : null;
            this.x = _data["x"] !== undefined ? _data["x"] : null;
            this.y = _data["y"] !== undefined ? _data["y"] : null;
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : null;
            this.geometryType = _data["geometryType"] !== undefined ? _data["geometryType"] : null;
            this.ogcGeometryType = _data["ogcGeometryType"] !== undefined ? _data["ogcGeometryType"] : null;
            this.boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : null;
            this.z = _data["z"] !== undefined ? _data["z"] : null;
            this.m = _data["m"] !== undefined ? _data["m"] : null;
        }
    };
    Point.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Point();
        result.init(data);
        return result;
    };
    Point.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : null;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (var _i = 0, _a = this.coordinates; _i < _a.length; _i++) {
                var item = _a[_i];
                data["coordinates"].push(item.toJSON());
            }
        }
        data["numPoints"] = this.numPoints !== undefined ? this.numPoints : null;
        data["isEmpty"] = this.isEmpty !== undefined ? this.isEmpty : null;
        data["dimension"] = this.dimension !== undefined ? this.dimension : null;
        data["boundaryDimension"] = this.boundaryDimension !== undefined ? this.boundaryDimension : null;
        data["x"] = this.x !== undefined ? this.x : null;
        data["y"] = this.y !== undefined ? this.y : null;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : null;
        data["geometryType"] = this.geometryType !== undefined ? this.geometryType : null;
        data["ogcGeometryType"] = this.ogcGeometryType !== undefined ? this.ogcGeometryType : null;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : null;
        data["z"] = this.z !== undefined ? this.z : null;
        data["m"] = this.m !== undefined ? this.m : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    Point.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Point();
        result.init(json);
        return result;
    };
    return Point;
}(Geometry));
exports.Point = Point;
var CoordinateSequence = /** @class */ (function () {
    function CoordinateSequence(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CoordinateSequence.prototype.init = function (_data) {
        if (_data) {
            this.dimension = _data["dimension"] !== undefined ? _data["dimension"] : null;
            this.measures = _data["measures"] !== undefined ? _data["measures"] : null;
            this.spatial = _data["spatial"] !== undefined ? _data["spatial"] : null;
            this.ordinates = _data["ordinates"] !== undefined ? _data["ordinates"] : null;
            this.hasZ = _data["hasZ"] !== undefined ? _data["hasZ"] : null;
            this.hasM = _data["hasM"] !== undefined ? _data["hasM"] : null;
            this.zOrdinateIndex = _data["zOrdinateIndex"] !== undefined ? _data["zOrdinateIndex"] : null;
            this.mOrdinateIndex = _data["mOrdinateIndex"] !== undefined ? _data["mOrdinateIndex"] : null;
            this.count = _data["count"] !== undefined ? _data["count"] : null;
        }
    };
    CoordinateSequence.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CoordinateSequence' cannot be instantiated.");
    };
    CoordinateSequence.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : null;
        data["measures"] = this.measures !== undefined ? this.measures : null;
        data["spatial"] = this.spatial !== undefined ? this.spatial : null;
        data["ordinates"] = this.ordinates !== undefined ? this.ordinates : null;
        data["hasZ"] = this.hasZ !== undefined ? this.hasZ : null;
        data["hasM"] = this.hasM !== undefined ? this.hasM : null;
        data["zOrdinateIndex"] = this.zOrdinateIndex !== undefined ? this.zOrdinateIndex : null;
        data["mOrdinateIndex"] = this.mOrdinateIndex !== undefined ? this.mOrdinateIndex : null;
        data["count"] = this.count !== undefined ? this.count : null;
        return data;
    };
    CoordinateSequence.prototype.clone = function () {
        throw new Error("The abstract class 'CoordinateSequence' cannot be instantiated.");
    };
    return CoordinateSequence;
}());
exports.CoordinateSequence = CoordinateSequence;
var Ordinates;
(function (Ordinates) {
    Ordinates[Ordinates["None"] = 0] = "None";
    Ordinates[Ordinates["X"] = 1] = "X";
    Ordinates[Ordinates["Spatial1"] = 1] = "Spatial1";
    Ordinates[Ordinates["Y"] = 2] = "Y";
    Ordinates[Ordinates["Spatial2"] = 2] = "Spatial2";
    Ordinates[Ordinates["XY"] = 3] = "XY";
    Ordinates[Ordinates["Spatial3"] = 4] = "Spatial3";
    Ordinates[Ordinates["Z"] = 4] = "Z";
    Ordinates[Ordinates["XYZ"] = 7] = "XYZ";
    Ordinates[Ordinates["Spatial4"] = 8] = "Spatial4";
    Ordinates[Ordinates["Spatial5"] = 16] = "Spatial5";
    Ordinates[Ordinates["Spatial6"] = 32] = "Spatial6";
    Ordinates[Ordinates["Spatial7"] = 64] = "Spatial7";
    Ordinates[Ordinates["Spatial8"] = 128] = "Spatial8";
    Ordinates[Ordinates["Spatial9"] = 256] = "Spatial9";
    Ordinates[Ordinates["Spatial10"] = 512] = "Spatial10";
    Ordinates[Ordinates["Spatial11"] = 1024] = "Spatial11";
    Ordinates[Ordinates["Spatial12"] = 2048] = "Spatial12";
    Ordinates[Ordinates["Spatial13"] = 4096] = "Spatial13";
    Ordinates[Ordinates["Spatial14"] = 8192] = "Spatial14";
    Ordinates[Ordinates["Spatial15"] = 16384] = "Spatial15";
    Ordinates[Ordinates["Spatial16"] = 32768] = "Spatial16";
    Ordinates[Ordinates["AllSpatialOrdinates"] = 65535] = "AllSpatialOrdinates";
    Ordinates[Ordinates["Measure1"] = 65536] = "Measure1";
    Ordinates[Ordinates["M"] = 65536] = "M";
    Ordinates[Ordinates["XYM"] = 65539] = "XYM";
    Ordinates[Ordinates["XYZM"] = 65543] = "XYZM";
    Ordinates[Ordinates["Measure2"] = 131072] = "Measure2";
    Ordinates[Ordinates["Measure3"] = 262144] = "Measure3";
    Ordinates[Ordinates["Measure4"] = 524288] = "Measure4";
    Ordinates[Ordinates["Measure5"] = 1048576] = "Measure5";
    Ordinates[Ordinates["Measure6"] = 2097152] = "Measure6";
    Ordinates[Ordinates["Measure7"] = 4194304] = "Measure7";
    Ordinates[Ordinates["Measure8"] = 8388608] = "Measure8";
    Ordinates[Ordinates["Measure9"] = 16777216] = "Measure9";
    Ordinates[Ordinates["Measure10"] = 33554432] = "Measure10";
    Ordinates[Ordinates["Measure11"] = 67108864] = "Measure11";
    Ordinates[Ordinates["Measure12"] = 134217728] = "Measure12";
    Ordinates[Ordinates["Measure13"] = 268435456] = "Measure13";
    Ordinates[Ordinates["Measure14"] = 536870912] = "Measure14";
    Ordinates[Ordinates["Measure15"] = 1073741824] = "Measure15";
    Ordinates[Ordinates["Measure16"] = -2147483648] = "Measure16";
    Ordinates[Ordinates["AllMeasureOrdinates"] = -65536] = "AllMeasureOrdinates";
    Ordinates[Ordinates["AllOrdinates"] = -1] = "AllOrdinates";
})(Ordinates = exports.Ordinates || (exports.Ordinates = {}));
var Coordinate = /** @class */ (function () {
    function Coordinate(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Coordinate.prototype.init = function (_data) {
        if (_data) {
            this.x = _data["x"] !== undefined ? _data["x"] : null;
            this.y = _data["y"] !== undefined ? _data["y"] : null;
            this.z = _data["z"] !== undefined ? _data["z"] : null;
            this.m = _data["m"] !== undefined ? _data["m"] : null;
            this.coordinateValue = _data["coordinateValue"] ? Coordinate.fromJS(_data["coordinateValue"]) : null;
        }
    };
    Coordinate.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Coordinate();
        result.init(data);
        return result;
    };
    Coordinate.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x !== undefined ? this.x : null;
        data["y"] = this.y !== undefined ? this.y : null;
        data["z"] = this.z !== undefined ? this.z : null;
        data["m"] = this.m !== undefined ? this.m : null;
        data["coordinateValue"] = this.coordinateValue ? this.coordinateValue.toJSON() : null;
        return data;
    };
    Coordinate.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Coordinate();
        result.init(json);
        return result;
    };
    return Coordinate;
}());
exports.Coordinate = Coordinate;
var Dimension;
(function (Dimension) {
    Dimension[Dimension["Point"] = 0] = "Point";
    Dimension[Dimension["Curve"] = 1] = "Curve";
    Dimension[Dimension["Surface"] = 2] = "Surface";
    Dimension[Dimension["Dontcare"] = -3] = "Dontcare";
    Dimension[Dimension["True"] = -2] = "True";
    Dimension[Dimension["False"] = -1] = "False";
})(Dimension = exports.Dimension || (exports.Dimension = {}));
var OgcGeometryType;
(function (OgcGeometryType) {
    OgcGeometryType[OgcGeometryType["Point"] = 1] = "Point";
    OgcGeometryType[OgcGeometryType["LineString"] = 2] = "LineString";
    OgcGeometryType[OgcGeometryType["Polygon"] = 3] = "Polygon";
    OgcGeometryType[OgcGeometryType["MultiPoint"] = 4] = "MultiPoint";
    OgcGeometryType[OgcGeometryType["MultiLineString"] = 5] = "MultiLineString";
    OgcGeometryType[OgcGeometryType["MultiPolygon"] = 6] = "MultiPolygon";
    OgcGeometryType[OgcGeometryType["GeometryCollection"] = 7] = "GeometryCollection";
    OgcGeometryType[OgcGeometryType["CircularString"] = 8] = "CircularString";
    OgcGeometryType[OgcGeometryType["CompoundCurve"] = 9] = "CompoundCurve";
    OgcGeometryType[OgcGeometryType["CurvePolygon"] = 10] = "CurvePolygon";
    OgcGeometryType[OgcGeometryType["MultiCurve"] = 11] = "MultiCurve";
    OgcGeometryType[OgcGeometryType["MultiSurface"] = 12] = "MultiSurface";
    OgcGeometryType[OgcGeometryType["Curve"] = 13] = "Curve";
    OgcGeometryType[OgcGeometryType["Surface"] = 14] = "Surface";
    OgcGeometryType[OgcGeometryType["PolyhedralSurface"] = 15] = "PolyhedralSurface";
    OgcGeometryType[OgcGeometryType["TIN"] = 16] = "TIN";
})(OgcGeometryType = exports.OgcGeometryType || (exports.OgcGeometryType = {}));
var GeometryFactory = /** @class */ (function () {
    function GeometryFactory(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GeometryFactory.prototype.init = function (_data) {
        if (_data) {
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : null;
            this.coordinateSequenceFactory = _data["coordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["coordinateSequenceFactory"]) : null;
            this.srid = _data["srid"] !== undefined ? _data["srid"] : null;
        }
    };
    GeometryFactory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GeometryFactory();
        result.init(data);
        return result;
    };
    GeometryFactory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : null;
        data["coordinateSequenceFactory"] = this.coordinateSequenceFactory ? this.coordinateSequenceFactory.toJSON() : null;
        data["srid"] = this.srid !== undefined ? this.srid : null;
        return data;
    };
    GeometryFactory.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GeometryFactory();
        result.init(json);
        return result;
    };
    return GeometryFactory;
}());
exports.GeometryFactory = GeometryFactory;
var PrecisionModel = /** @class */ (function () {
    function PrecisionModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PrecisionModel.prototype.init = function (_data) {
        if (_data) {
            this.isFloating = _data["isFloating"] !== undefined ? _data["isFloating"] : null;
            this.maximumSignificantDigits = _data["maximumSignificantDigits"] !== undefined ? _data["maximumSignificantDigits"] : null;
            this.scale = _data["scale"] !== undefined ? _data["scale"] : null;
            this.precisionModelType = _data["precisionModelType"] !== undefined ? _data["precisionModelType"] : null;
        }
    };
    PrecisionModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PrecisionModel();
        result.init(data);
        return result;
    };
    PrecisionModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isFloating"] = this.isFloating !== undefined ? this.isFloating : null;
        data["maximumSignificantDigits"] = this.maximumSignificantDigits !== undefined ? this.maximumSignificantDigits : null;
        data["scale"] = this.scale !== undefined ? this.scale : null;
        data["precisionModelType"] = this.precisionModelType !== undefined ? this.precisionModelType : null;
        return data;
    };
    PrecisionModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PrecisionModel();
        result.init(json);
        return result;
    };
    return PrecisionModel;
}());
exports.PrecisionModel = PrecisionModel;
var PrecisionModels;
(function (PrecisionModels) {
    PrecisionModels[PrecisionModels["Floating"] = 0] = "Floating";
    PrecisionModels[PrecisionModels["FloatingSingle"] = 1] = "FloatingSingle";
    PrecisionModels[PrecisionModels["Fixed"] = 2] = "Fixed";
})(PrecisionModels = exports.PrecisionModels || (exports.PrecisionModels = {}));
var CoordinateSequenceFactory = /** @class */ (function () {
    function CoordinateSequenceFactory(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CoordinateSequenceFactory.prototype.init = function (_data) {
        if (_data) {
            this.ordinates = _data["ordinates"] !== undefined ? _data["ordinates"] : null;
        }
    };
    CoordinateSequenceFactory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CoordinateSequenceFactory' cannot be instantiated.");
    };
    CoordinateSequenceFactory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["ordinates"] = this.ordinates !== undefined ? this.ordinates : null;
        return data;
    };
    CoordinateSequenceFactory.prototype.clone = function () {
        throw new Error("The abstract class 'CoordinateSequenceFactory' cannot be instantiated.");
    };
    return CoordinateSequenceFactory;
}());
exports.CoordinateSequenceFactory = CoordinateSequenceFactory;
var Envelope = /** @class */ (function () {
    function Envelope(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Envelope.prototype.init = function (_data) {
        if (_data) {
            this.isNull = _data["isNull"] !== undefined ? _data["isNull"] : null;
            this.width = _data["width"] !== undefined ? _data["width"] : null;
            this.height = _data["height"] !== undefined ? _data["height"] : null;
            this.minX = _data["minX"] !== undefined ? _data["minX"] : null;
            this.maxX = _data["maxX"] !== undefined ? _data["maxX"] : null;
            this.minY = _data["minY"] !== undefined ? _data["minY"] : null;
            this.maxY = _data["maxY"] !== undefined ? _data["maxY"] : null;
            this.area = _data["area"] !== undefined ? _data["area"] : null;
            this.minExtent = _data["minExtent"] !== undefined ? _data["minExtent"] : null;
            this.maxExtent = _data["maxExtent"] !== undefined ? _data["maxExtent"] : null;
            this.centre = _data["centre"] ? Coordinate.fromJS(_data["centre"]) : null;
        }
    };
    Envelope.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Envelope();
        result.init(data);
        return result;
    };
    Envelope.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isNull"] = this.isNull !== undefined ? this.isNull : null;
        data["width"] = this.width !== undefined ? this.width : null;
        data["height"] = this.height !== undefined ? this.height : null;
        data["minX"] = this.minX !== undefined ? this.minX : null;
        data["maxX"] = this.maxX !== undefined ? this.maxX : null;
        data["minY"] = this.minY !== undefined ? this.minY : null;
        data["maxY"] = this.maxY !== undefined ? this.maxY : null;
        data["area"] = this.area !== undefined ? this.area : null;
        data["minExtent"] = this.minExtent !== undefined ? this.minExtent : null;
        data["maxExtent"] = this.maxExtent !== undefined ? this.maxExtent : null;
        data["centre"] = this.centre ? this.centre.toJSON() : null;
        return data;
    };
    Envelope.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Envelope();
        result.init(json);
        return result;
    };
    return Envelope;
}());
exports.Envelope = Envelope;
var AdvertisementCategory = /** @class */ (function (_super) {
    __extends(AdvertisementCategory, _super);
    function AdvertisementCategory(data) {
        return _super.call(this, data) || this;
    }
    AdvertisementCategory.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.advertisementCategoryId = _data["advertisementCategoryId"] !== undefined ? _data["advertisementCategoryId"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.code = _data["code"] !== undefined ? _data["code"] : null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : null;
            this.casualDating = _data["casualDating"] !== undefined ? _data["casualDating"] : null;
        }
    };
    AdvertisementCategory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertisementCategory();
        result.init(data);
        return result;
    };
    AdvertisementCategory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdvertisementCategory.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertisementCategory();
        result.init(json);
        return result;
    };
    return AdvertisementCategory;
}(BaseModel));
exports.AdvertisementCategory = AdvertisementCategory;
var AdvertisementImage = /** @class */ (function (_super) {
    __extends(AdvertisementImage, _super);
    function AdvertisementImage(data) {
        return _super.call(this, data) || this;
    }
    AdvertisementImage.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.advertisementImageId = _data["advertisementImageId"] !== undefined ? _data["advertisementImageId"] : null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
            this.advertisement = _data["advertisement"] ? Advertisement.fromJS(_data["advertisement"]) : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.orgFileName = _data["orgFileName"] !== undefined ? _data["orgFileName"] : null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : null;
            this.isMain = _data["isMain"] !== undefined ? _data["isMain"] : null;
        }
    };
    AdvertisementImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertisementImage();
        result.init(data);
        return result;
    };
    AdvertisementImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementImageId"] = this.advertisementImageId !== undefined ? this.advertisementImageId : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null;
        data["isMain"] = this.isMain !== undefined ? this.isMain : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AdvertisementImage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertisementImage();
        result.init(json);
        return result;
    };
    return AdvertisementImage;
}(BaseModel));
exports.AdvertisementImage = AdvertisementImage;
var Conversation = /** @class */ (function () {
    function Conversation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Conversation.prototype.init = function (_data) {
        if (_data) {
            this.conversationId = _data["conversationId"] !== undefined ? _data["conversationId"] : null;
            this.senderEmail = _data["senderEmail"] !== undefined ? _data["senderEmail"] : null;
            this.senderNick = _data["senderNick"] !== undefined ? _data["senderNick"] : null;
            this.receiverNick = _data["receiverNick"] !== undefined ? _data["receiverNick"] : null;
            this.receiverEmail = _data["receiverEmail"] !== undefined ? _data["receiverEmail"] : null;
            this.conversationKey = _data["conversationKey"] !== undefined ? _data["conversationKey"] : null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
            this.ownerUserId = _data["ownerUserId"] !== undefined ? _data["ownerUserId"] : null;
            this.ownerUser = _data["ownerUser"] ? User.fromJS(_data["ownerUser"]) : null;
            this.receiverUserId = _data["receiverUserId"] !== undefined ? _data["receiverUserId"] : null;
            this.receiverUser = _data["receiverUser"] ? User.fromJS(_data["receiverUser"]) : null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
            this.advertisement = _data["advertisement"] ? Advertisement.fromJS(_data["advertisement"]) : null;
            if (Array.isArray(_data["messages"])) {
                this.messages = [];
                for (var _i = 0, _a = _data["messages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.messages.push(ConversationMessage.fromJS(item));
                }
            }
        }
    };
    Conversation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Conversation();
        result.init(data);
        return result;
    };
    Conversation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : null;
        data["senderEmail"] = this.senderEmail !== undefined ? this.senderEmail : null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : null;
        data["receiverNick"] = this.receiverNick !== undefined ? this.receiverNick : null;
        data["receiverEmail"] = this.receiverEmail !== undefined ? this.receiverEmail : null;
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["ownerUserId"] = this.ownerUserId !== undefined ? this.ownerUserId : null;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : null;
        data["receiverUserId"] = this.receiverUserId !== undefined ? this.receiverUserId : null;
        data["receiverUser"] = this.receiverUser ? this.receiverUser.toJSON() : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (var _i = 0, _a = this.messages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["messages"].push(item.toJSON());
            }
        }
        return data;
    };
    Conversation.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Conversation();
        result.init(json);
        return result;
    };
    return Conversation;
}());
exports.Conversation = Conversation;
var User = /** @class */ (function () {
    function User(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    User.prototype.init = function (_data) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : null;
            this.updatedAt = _data["updatedAt"] ? moment(_data["updatedAt"].toString()) : null;
            this.nick = _data["nick"] !== undefined ? _data["nick"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null;
            this.password = _data["password"] !== undefined ? _data["password"] : null;
            this.passwordSalt = _data["passwordSalt"] !== undefined ? _data["passwordSalt"] : null;
            this.isDemo = _data["isDemo"] !== undefined ? _data["isDemo"] : null;
            this.isInternal = _data["isInternal"] !== undefined ? _data["isInternal"] : null;
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : null;
            this.isEmailVerified = _data["isEmailVerified"] !== undefined ? _data["isEmailVerified"] : null;
            this.isPremium = _data["isPremium"] !== undefined ? _data["isPremium"] : null;
            this.isPhoneVerified = _data["isPhoneVerified"] !== undefined ? _data["isPhoneVerified"] : null;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null;
            this.city = _data["city"] !== undefined ? _data["city"] : null;
            this.state = _data["state"] !== undefined ? _data["state"] : null;
            this.location = _data["location"] ? Point.fromJS(_data["location"]) : null;
            this.premiumAdTokens = _data["premiumAdTokens"] !== undefined ? _data["premiumAdTokens"] : null;
            this.writeAdTokens = _data["writeAdTokens"] !== undefined ? _data["writeAdTokens"] : null;
            this.subscribtionExpiration = _data["subscribtionExpiration"] ? moment(_data["subscribtionExpiration"].toString()) : null;
        }
    };
    User.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new User();
        result.init(data);
        return result;
    };
    User.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null;
        data["nick"] = this.nick !== undefined ? this.nick : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["password"] = this.password !== undefined ? this.password : null;
        data["passwordSalt"] = this.passwordSalt !== undefined ? this.passwordSalt : null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : null;
        data["isInternal"] = this.isInternal !== undefined ? this.isInternal : null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : null;
        data["isEmailVerified"] = this.isEmailVerified !== undefined ? this.isEmailVerified : null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : null;
        data["isPhoneVerified"] = this.isPhoneVerified !== undefined ? this.isPhoneVerified : null;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["location"] = this.location ? this.location.toJSON() : null;
        data["premiumAdTokens"] = this.premiumAdTokens !== undefined ? this.premiumAdTokens : null;
        data["writeAdTokens"] = this.writeAdTokens !== undefined ? this.writeAdTokens : null;
        data["subscribtionExpiration"] = this.subscribtionExpiration ? this.subscribtionExpiration.toISOString() : null;
        return data;
    };
    User.prototype.clone = function () {
        var json = this.toJSON();
        var result = new User();
        result.init(json);
        return result;
    };
    return User;
}());
exports.User = User;
var ConversationMessage = /** @class */ (function () {
    function ConversationMessage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConversationMessage.prototype.init = function (_data) {
        if (_data) {
            this.conversationMessageId = _data["conversationMessageId"] !== undefined ? _data["conversationMessageId"] : null;
            this.conversation = _data["conversation"] ? Conversation.fromJS(_data["conversation"]) : null;
            this.content = _data["content"] !== undefined ? _data["content"] : null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
            this.sender = _data["sender"] ? User.fromJS(_data["sender"]) : null;
            this.senderId = _data["senderId"] !== undefined ? _data["senderId"] : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (var _i = 0, _a = _data["images"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.images.push(ConversationImage.fromJS(item));
                }
            }
            this.isRead = _data["isRead"] !== undefined ? _data["isRead"] : null;
        }
    };
    ConversationMessage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationMessage();
        result.init(data);
        return result;
    };
    ConversationMessage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationMessageId"] = this.conversationMessageId !== undefined ? this.conversationMessageId : null;
        data["conversation"] = this.conversation ? this.conversation.toJSON() : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["sender"] = this.sender ? this.sender.toJSON() : null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : null;
        data["title"] = this.title !== undefined ? this.title : null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _i = 0, _a = this.images; _i < _a.length; _i++) {
                var item = _a[_i];
                data["images"].push(item.toJSON());
            }
        }
        data["isRead"] = this.isRead !== undefined ? this.isRead : null;
        return data;
    };
    ConversationMessage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationMessage();
        result.init(json);
        return result;
    };
    return ConversationMessage;
}());
exports.ConversationMessage = ConversationMessage;
var ConversationImage = /** @class */ (function () {
    function ConversationImage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConversationImage.prototype.init = function (_data) {
        if (_data) {
            this.conversationImageId = _data["conversationImageId"] !== undefined ? _data["conversationImageId"] : null;
            this.conversationMessage = _data["conversationMessage"] ? ConversationMessage.fromJS(_data["conversationMessage"]) : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
        }
    };
    ConversationImage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConversationImage();
        result.init(data);
        return result;
    };
    ConversationImage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["conversationImageId"] = this.conversationImageId !== undefined ? this.conversationImageId : null;
        data["conversationMessage"] = this.conversationMessage ? this.conversationMessage.toJSON() : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        return data;
    };
    ConversationImage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ConversationImage();
        result.init(json);
        return result;
    };
    return ConversationImage;
}());
exports.ConversationImage = ConversationImage;
var AdvertisementSetting = /** @class */ (function () {
    function AdvertisementSetting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdvertisementSetting.prototype.init = function (_data) {
        if (_data) {
            this.advertisementSettingId = _data["advertisementSettingId"] !== undefined ? _data["advertisementSettingId"] : null;
            this.advertisementId = _data["advertisementId"] !== undefined ? _data["advertisementId"] : null;
            this.showAs = _data["showAs"] !== undefined ? _data["showAs"] : null;
            this.advertisement = _data["advertisement"] ? Advertisement.fromJS(_data["advertisement"]) : null;
        }
    };
    AdvertisementSetting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdvertisementSetting();
        result.init(data);
        return result;
    };
    AdvertisementSetting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["advertisementSettingId"] = this.advertisementSettingId !== undefined ? this.advertisementSettingId : null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : null;
        data["showAs"] = this.showAs !== undefined ? this.showAs : null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : null;
        return data;
    };
    AdvertisementSetting.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AdvertisementSetting();
        result.init(json);
        return result;
    };
    return AdvertisementSetting;
}());
exports.AdvertisementSetting = AdvertisementSetting;
var VerifyPhoneResponseModel = /** @class */ (function (_super) {
    __extends(VerifyPhoneResponseModel, _super);
    function VerifyPhoneResponseModel(data) {
        return _super.call(this, data) || this;
    }
    VerifyPhoneResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    VerifyPhoneResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifyPhoneResponseModel();
        result.init(data);
        return result;
    };
    VerifyPhoneResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    VerifyPhoneResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new VerifyPhoneResponseModel();
        result.init(json);
        return result;
    };
    return VerifyPhoneResponseModel;
}(ResponseBaseModel));
exports.VerifyPhoneResponseModel = VerifyPhoneResponseModel;
var VerifyPhoneModel = /** @class */ (function () {
    function VerifyPhoneModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VerifyPhoneModel.prototype.init = function (_data) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
        }
    };
    VerifyPhoneModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifyPhoneModel();
        result.init(data);
        return result;
    };
    VerifyPhoneModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        return data;
    };
    VerifyPhoneModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new VerifyPhoneModel();
        result.init(json);
        return result;
    };
    return VerifyPhoneModel;
}());
exports.VerifyPhoneModel = VerifyPhoneModel;
var ZipRequest = /** @class */ (function () {
    function ZipRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZipRequest.prototype.init = function (_data) {
        if (_data) {
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null;
        }
    };
    ZipRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZipRequest();
        result.init(data);
        return result;
    };
    ZipRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["zip"] = this.zip !== undefined ? this.zip : null;
        return data;
    };
    ZipRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ZipRequest();
        result.init(json);
        return result;
    };
    return ZipRequest;
}());
exports.ZipRequest = ZipRequest;
var WeatherForecast = /** @class */ (function () {
    function WeatherForecast(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    WeatherForecast.prototype.init = function (_data) {
        if (_data) {
            this.dateFormatted = _data["dateFormatted"] !== undefined ? _data["dateFormatted"] : null;
            this.temperatureC = _data["temperatureC"] !== undefined ? _data["temperatureC"] : null;
            this.summary = _data["summary"] !== undefined ? _data["summary"] : null;
            this.temperatureF = _data["temperatureF"] !== undefined ? _data["temperatureF"] : null;
        }
    };
    WeatherForecast.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new WeatherForecast();
        result.init(data);
        return result;
    };
    WeatherForecast.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dateFormatted"] = this.dateFormatted !== undefined ? this.dateFormatted : null;
        data["temperatureC"] = this.temperatureC !== undefined ? this.temperatureC : null;
        data["summary"] = this.summary !== undefined ? this.summary : null;
        data["temperatureF"] = this.temperatureF !== undefined ? this.temperatureF : null;
        return data;
    };
    WeatherForecast.prototype.clone = function () {
        var json = this.toJSON();
        var result = new WeatherForecast();
        result.init(json);
        return result;
    };
    return WeatherForecast;
}());
exports.WeatherForecast = WeatherForecast;
var ServiceResponseBase = /** @class */ (function () {
    function ServiceResponseBase(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceResponseBase.prototype.init = function (_data) {
        if (_data) {
            this.isError = _data["isError"] !== undefined ? _data["isError"] : null;
            this.message = _data["message"] !== undefined ? _data["message"] : null;
        }
    };
    ServiceResponseBase.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServiceResponseBase' cannot be instantiated.");
    };
    ServiceResponseBase.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isError"] = this.isError !== undefined ? this.isError : null;
        data["message"] = this.message !== undefined ? this.message : null;
        return data;
    };
    ServiceResponseBase.prototype.clone = function () {
        throw new Error("The abstract class 'ServiceResponseBase' cannot be instantiated.");
    };
    return ServiceResponseBase;
}());
exports.ServiceResponseBase = ServiceResponseBase;
var CreateServiceResponse = /** @class */ (function (_super) {
    __extends(CreateServiceResponse, _super);
    function CreateServiceResponse(data) {
        return _super.call(this, data) || this;
    }
    CreateServiceResponse.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.isCreated = _data["isCreated"] !== undefined ? _data["isCreated"] : null;
            this.token = _data["token"] !== undefined ? _data["token"] : null;
        }
    };
    CreateServiceResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateServiceResponse();
        result.init(data);
        return result;
    };
    CreateServiceResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : null;
        data["token"] = this.token !== undefined ? this.token : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    CreateServiceResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CreateServiceResponse();
        result.init(json);
        return result;
    };
    return CreateServiceResponse;
}(ServiceResponseBase));
exports.CreateServiceResponse = CreateServiceResponse;
var Subscribe = /** @class */ (function () {
    function Subscribe(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Subscribe.prototype.init = function (_data) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null;
            this.expirationDate = _data["expirationDate"] !== undefined ? _data["expirationDate"] : null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null;
            this.securityCode = _data["securityCode"] !== undefined ? _data["securityCode"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.period = _data["period"] !== undefined ? _data["period"] : null;
        }
    };
    Subscribe.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Subscribe();
        result.init(data);
        return result;
    };
    Subscribe.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["period"] = this.period !== undefined ? this.period : null;
        return data;
    };
    Subscribe.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Subscribe();
        result.init(json);
        return result;
    };
    return Subscribe;
}());
exports.Subscribe = Subscribe;
var Period;
(function (Period) {
    Period[Period["Year"] = 1] = "Year";
    Period[Period["Month"] = 2] = "Month";
    Period[Period["SinglePremiumAd"] = 3] = "SinglePremiumAd";
})(Period = exports.Period || (exports.Period = {}));
var SubscribtionData = /** @class */ (function () {
    function SubscribtionData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscribtionData.prototype.init = function (_data) {
        if (_data) {
            this.subscribtionId = _data["subscribtionId"] !== undefined ? _data["subscribtionId"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.creditCard = _data["creditCard"] !== undefined ? _data["creditCard"] : null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null;
            this.type = _data["type"] !== undefined ? _data["type"] : null;
            this.price = _data["price"] !== undefined ? _data["price"] : null;
            this.nextBillingDate = _data["nextBillingDate"] ? moment(_data["nextBillingDate"].toString()) : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
        }
    };
    SubscribtionData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscribtionData();
        result.init(data);
        return result;
    };
    SubscribtionData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subscribtionId"] = this.subscribtionId !== undefined ? this.subscribtionId : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["creditCard"] = this.creditCard !== undefined ? this.creditCard : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["type"] = this.type !== undefined ? this.type : null;
        data["price"] = this.price !== undefined ? this.price : null;
        data["nextBillingDate"] = this.nextBillingDate ? this.nextBillingDate.toISOString() : null;
        data["status"] = this.status !== undefined ? this.status : null;
        return data;
    };
    SubscribtionData.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SubscribtionData();
        result.init(json);
        return result;
    };
    return SubscribtionData;
}());
exports.SubscribtionData = SubscribtionData;
var Status;
(function (Status) {
    Status[Status["Active"] = 0] = "Active";
    Status[Status["InActive"] = 1] = "InActive";
    Status[Status["Canceled"] = 2] = "Canceled";
})(Status = exports.Status || (exports.Status = {}));
var AddPremiumAdTokenResponse = /** @class */ (function (_super) {
    __extends(AddPremiumAdTokenResponse, _super);
    function AddPremiumAdTokenResponse(data) {
        return _super.call(this, data) || this;
    }
    AddPremiumAdTokenResponse.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.isCreated = _data["isCreated"] !== undefined ? _data["isCreated"] : null;
        }
    };
    AddPremiumAdTokenResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddPremiumAdTokenResponse();
        result.init(data);
        return result;
    };
    AddPremiumAdTokenResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AddPremiumAdTokenResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddPremiumAdTokenResponse();
        result.init(json);
        return result;
    };
    return AddPremiumAdTokenResponse;
}(ServiceResponseBase));
exports.AddPremiumAdTokenResponse = AddPremiumAdTokenResponse;
var AddPremiumAdToken = /** @class */ (function () {
    function AddPremiumAdToken(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddPremiumAdToken.prototype.init = function (_data) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null;
            this.expirationDate = _data["expirationDate"] !== undefined ? _data["expirationDate"] : null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null;
            this.securityCode = _data["securityCode"] !== undefined ? _data["securityCode"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
        }
    };
    AddPremiumAdToken.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddPremiumAdToken();
        result.init(data);
        return result;
    };
    AddPremiumAdToken.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        return data;
    };
    AddPremiumAdToken.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddPremiumAdToken();
        result.init(json);
        return result;
    };
    return AddPremiumAdToken;
}());
exports.AddPremiumAdToken = AddPremiumAdToken;
var AddWriteAdTokenResponse = /** @class */ (function (_super) {
    __extends(AddWriteAdTokenResponse, _super);
    function AddWriteAdTokenResponse(data) {
        return _super.call(this, data) || this;
    }
    AddWriteAdTokenResponse.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.isCreated = _data["isCreated"] !== undefined ? _data["isCreated"] : null;
        }
    };
    AddWriteAdTokenResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddWriteAdTokenResponse();
        result.init(data);
        return result;
    };
    AddWriteAdTokenResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    AddWriteAdTokenResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddWriteAdTokenResponse();
        result.init(json);
        return result;
    };
    return AddWriteAdTokenResponse;
}(ServiceResponseBase));
exports.AddWriteAdTokenResponse = AddWriteAdTokenResponse;
var AddWriteAdToken = /** @class */ (function () {
    function AddWriteAdToken(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddWriteAdToken.prototype.init = function (_data) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null;
            this.expirationDate = _data["expirationDate"] !== undefined ? _data["expirationDate"] : null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null;
            this.securityCode = _data["securityCode"] !== undefined ? _data["securityCode"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
        }
    };
    AddWriteAdToken.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddWriteAdToken();
        result.init(data);
        return result;
    };
    AddWriteAdToken.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : null;
        data["zip"] = this.zip !== undefined ? this.zip : null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        return data;
    };
    AddWriteAdToken.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddWriteAdToken();
        result.init(json);
        return result;
    };
    return AddWriteAdToken;
}());
exports.AddWriteAdToken = AddWriteAdToken;
var TupleOfIntegerAndDateTime = /** @class */ (function () {
    function TupleOfIntegerAndDateTime(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TupleOfIntegerAndDateTime.prototype.init = function (_data) {
        if (_data) {
            this.item1 = _data["item1"] !== undefined ? _data["item1"] : null;
            this.item2 = _data["item2"] ? moment(_data["item2"].toString()) : null;
        }
    };
    TupleOfIntegerAndDateTime.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TupleOfIntegerAndDateTime();
        result.init(data);
        return result;
    };
    TupleOfIntegerAndDateTime.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 !== undefined ? this.item1 : null;
        data["item2"] = this.item2 ? this.item2.toISOString() : null;
        return data;
    };
    TupleOfIntegerAndDateTime.prototype.clone = function () {
        var json = this.toJSON();
        var result = new TupleOfIntegerAndDateTime();
        result.init(json);
        return result;
    };
    return TupleOfIntegerAndDateTime;
}());
exports.TupleOfIntegerAndDateTime = TupleOfIntegerAndDateTime;
var DemoAdvertisementGetTest = /** @class */ (function () {
    function DemoAdvertisementGetTest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DemoAdvertisementGetTest.prototype.init = function (_data) {
        if (_data) {
            this.request = _data["request"] ? AdveristmentGetModel.fromJS(_data["request"]) : null;
            this.date = _data["date"] ? moment(_data["date"].toString()) : null;
        }
    };
    DemoAdvertisementGetTest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DemoAdvertisementGetTest();
        result.init(data);
        return result;
    };
    DemoAdvertisementGetTest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : null;
        data["date"] = this.date ? this.date.toISOString() : null;
        return data;
    };
    DemoAdvertisementGetTest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DemoAdvertisementGetTest();
        result.init(json);
        return result;
    };
    return DemoAdvertisementGetTest;
}());
exports.DemoAdvertisementGetTest = DemoAdvertisementGetTest;
var RegistrationResponseModel = /** @class */ (function (_super) {
    __extends(RegistrationResponseModel, _super);
    function RegistrationResponseModel(data) {
        return _super.call(this, data) || this;
    }
    RegistrationResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    RegistrationResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegistrationResponseModel();
        result.init(data);
        return result;
    };
    RegistrationResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    RegistrationResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RegistrationResponseModel();
        result.init(json);
        return result;
    };
    return RegistrationResponseModel;
}(ResponseBaseModel));
exports.RegistrationResponseModel = RegistrationResponseModel;
var RegistrationModel = /** @class */ (function () {
    function RegistrationModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegistrationModel.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            this.password = _data["password"] !== undefined ? _data["password"] : null;
            this.passwordConfirmation = _data["passwordConfirmation"] !== undefined ? _data["passwordConfirmation"] : null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null;
            this.city = _data["city"] !== undefined ? _data["city"] : null;
            this.state = _data["state"] !== undefined ? _data["state"] : null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null;
        }
    };
    RegistrationModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegistrationModel();
        result.init(data);
        return result;
    };
    RegistrationModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null;
        data["password"] = this.password !== undefined ? this.password : null;
        data["passwordConfirmation"] = this.passwordConfirmation !== undefined ? this.passwordConfirmation : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        return data;
    };
    RegistrationModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RegistrationModel();
        result.init(json);
        return result;
    };
    return RegistrationModel;
}());
exports.RegistrationModel = RegistrationModel;
var ResetPasswordResponseModel = /** @class */ (function (_super) {
    __extends(ResetPasswordResponseModel, _super);
    function ResetPasswordResponseModel(data) {
        return _super.call(this, data) || this;
    }
    ResetPasswordResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
    };
    ResetPasswordResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordResponseModel();
        result.init(data);
        return result;
    };
    ResetPasswordResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    ResetPasswordResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ResetPasswordResponseModel();
        result.init(json);
        return result;
    };
    return ResetPasswordResponseModel;
}(ResponseBaseModel));
exports.ResetPasswordResponseModel = ResetPasswordResponseModel;
var ResetPasswordModel = /** @class */ (function () {
    function ResetPasswordModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordModel.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null;
        }
    };
    ResetPasswordModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordModel();
        result.init(data);
        return result;
    };
    ResetPasswordModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null;
        return data;
    };
    ResetPasswordModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ResetPasswordModel();
        result.init(json);
        return result;
    };
    return ResetPasswordModel;
}());
exports.ResetPasswordModel = ResetPasswordModel;
var GetEmailFromCodeResponseModel = /** @class */ (function (_super) {
    __extends(GetEmailFromCodeResponseModel, _super);
    function GetEmailFromCodeResponseModel(data) {
        return _super.call(this, data) || this;
    }
    GetEmailFromCodeResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null;
        }
    };
    GetEmailFromCodeResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEmailFromCodeResponseModel();
        result.init(data);
        return result;
    };
    GetEmailFromCodeResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    GetEmailFromCodeResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GetEmailFromCodeResponseModel();
        result.init(json);
        return result;
    };
    return GetEmailFromCodeResponseModel;
}(ResponseBaseModel));
exports.GetEmailFromCodeResponseModel = GetEmailFromCodeResponseModel;
var NewPasswordModel = /** @class */ (function () {
    function NewPasswordModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NewPasswordModel.prototype.init = function (_data) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            this.code = _data["code"] !== undefined ? _data["code"] : null;
            this.password = _data["password"] !== undefined ? _data["password"] : null;
            this.passwordConfirmation = _data["passwordConfirmation"] !== undefined ? _data["passwordConfirmation"] : null;
        }
    };
    NewPasswordModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NewPasswordModel();
        result.init(data);
        return result;
    };
    NewPasswordModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["password"] = this.password !== undefined ? this.password : null;
        data["passwordConfirmation"] = this.passwordConfirmation !== undefined ? this.passwordConfirmation : null;
        return data;
    };
    NewPasswordModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new NewPasswordModel();
        result.init(json);
        return result;
    };
    return NewPasswordModel;
}());
exports.NewPasswordModel = NewPasswordModel;
var ValidateResponseModel = /** @class */ (function (_super) {
    __extends(ValidateResponseModel, _super);
    function ValidateResponseModel(data) {
        return _super.call(this, data) || this;
    }
    ValidateResponseModel.prototype.init = function (_data) {
        _super.prototype.init.call(this, _data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
            this.userPhone = _data["userPhone"] !== undefined ? _data["userPhone"] : null;
        }
    };
    ValidateResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidateResponseModel();
        result.init(data);
        return result;
    };
    ValidateResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["userPhone"] = this.userPhone !== undefined ? this.userPhone : null;
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    ValidateResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ValidateResponseModel();
        result.init(json);
        return result;
    };
    return ValidateResponseModel;
}(ResponseBaseModel));
exports.ValidateResponseModel = ValidateResponseModel;
var ValidatePhoneModel = /** @class */ (function () {
    function ValidatePhoneModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidatePhoneModel.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null;
        }
    };
    ValidatePhoneModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidatePhoneModel();
        result.init(data);
        return result;
    };
    ValidatePhoneModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        return data;
    };
    ValidatePhoneModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ValidatePhoneModel();
        result.init(json);
        return result;
    };
    return ValidatePhoneModel;
}());
exports.ValidatePhoneModel = ValidatePhoneModel;
var ValidateModel = /** @class */ (function () {
    function ValidateModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidateModel.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null;
            this.type = _data["type"] !== undefined ? _data["type"] : null;
            this.code = _data["code"] !== undefined ? _data["code"] : null;
        }
    };
    ValidateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidateModel();
        result.init(data);
        return result;
    };
    ValidateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null;
        data["type"] = this.type !== undefined ? this.type : null;
        data["code"] = this.code !== undefined ? this.code : null;
        return data;
    };
    ValidateModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ValidateModel();
        result.init(json);
        return result;
    };
    return ValidateModel;
}());
exports.ValidateModel = ValidateModel;
var SwaggerException = /** @class */ (function (_super) {
    __extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
exports.SwaggerException = SwaggerException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return rxjs_1.throwError(result);
    else
        return rxjs_1.throwError(new SwaggerException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new rxjs_1.Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function (event) {
                observer.next(event.target.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
